import zhHans from 'vuetify/es5/locale/zh-Hans';
export default {
    ...zhHans,
    setting: {
        language: "Опростен китайски",
        dialogDetermine: "Сигурен",
        dreivatives: "Договор за доставка",
        markets: "Цитати",
        assets: "активи",
        liquidity: "Добив на ликвидност",
        helpCentre: "Помощен център",
        announcementCenter: "Център за съобщения",
        about: "относно",
        bulletinCentre: "Център за съобщения",
        serviceAgreement: "Споразумение за обслужване",
        support: "поддържа",
        onlineSupportCustomerService: "онлайн услуга",
        suggestionsAndFeedback: "Предложения и отзиви",
        service: "Сервирайте",
        download: "Изтегли",
        coinApplication: "Приложение за изброяване на монети",
        privacyStatement: "Декларация за поверителност",
        trade: "договорна търговия",
        standardConteact: "Устойчив",
        signOut: "отписване",
        assetWallets: "Портфейл за активи",
        financeRecords: "Записи за промени в акаунта",
        identification: "Удостоверяване",
        personalCenter: "Личен център",
        chooseLanguage: "Изберете език",
        tips: "намек",
        dark: "тъмен режим",
        light: "дневен режим",
        languageTitle: "език",
        convertCurrency: "Преобразуване на валута",
        cancel: "Отказ",
        aboutUs: "за нас",
        standard: "Приемственост на стандарта",
        share: "дял",
        introduce: "Въведение в платформата",
        set: "настройвам",
        changePassword: "Промяна на паролата за вход",
        denomination: "Валута на котировката",
        color: "Цветова конфигурация",
        code: "номер на версията",
        color1: "Червеното се издига и зеленото пада",
        color2: "Зеленото се издига и червеното пада",
        setLangue: "езикова настройка",
        vip: "VIP права",
        vip2: "Текущо VIP ниво",
        safeMenu: "Център за сигурност",
        conventional: "конвенционален",
        other: "друго",
        quickTips: "Добавете до 3 функционални бутона за бърз достъп",
        quickTransaction: "Бърза транзакция",
        safeConvenient: "Безопасно и удобно",
        timeSharing: "споделяне на времето",
        currentLevel: "текущо ниво",
        levelBenefits: "Доход на ниво %{level}",
        teamLevel: "Отборно ниво",
        levelLower: "%{level}подчинен",
        rules: "Описание на правилото",
        bindWithdrawalAddress: "Обвързване на адрес за теглене",
        tipsBindWithdrawalAddress: "Все още не сте обвързали адреса си за теглене, моля, обвържете го първо",
        walletAddressFormatIncorrect: "Форматът на адреса на Wallet е неправилен",
        tradeRules1: "Прогнозирайте възхода и спада в бъдещия период. Цената в момента на поръчката се използва като начална цена, а цената в последната секунда от периода на сетълмент се използва като цена за сетълмент цена е по-ниска от началната цена, това означава намаление.",
        tradeRules2: "1. Какво е договор?",
        tradeRules3: "Тази платформа предоставя безсрочни договори, базирани на USDT. Потребителите могат да преценят покачването или спадането и да изберат да купуват дълги или да продават къси договори, за да получат печалби от покачването/спадането на цените на цифровите активи. Безсрочните договори нямат дата на доставка и потребителите могат да ги държат завинаги.",
        tradeRules4: "2.Какво е марж",
        tradeRules5: "На пазара на виртуални договори потребителите трябва само да платят малка сума средства в определена пропорция според цената на договора като финансова гаранция за изпълнението на договора, след което могат да участват в покупко-продажбата на договора. Този вид средства са виртуалните договорни депозити. \nДоговорите на тази платформа приемат модела на отделен маржин на отделни сметки. Всяка валута съответства на договорна сметка и позициите на различни договорни валути са независими една от друга и трансферите и транзакциите между различни договорни сметки не се влияят една на друга. След като бъде открита договорната сметка на потребителя, рисковете и ползите от всички позиции, поддържани в договорната сметка, ще бъдат изчислени заедно.",
        tradeRules6: "3. Как да изчислим маржа",
        tradeRules7: "Маржин на позиция = номинална стойност на договора * брой отворени договори / множител на ливъридж\nзамразен маржин = сумата от маржовете на всички успешно поставени поръчки и отварящи поръчки в текущата поръчка\наличен маржин = баланс на сметката - маржин на позиция - замразен маржин",
        tradeRules8: "4.Как да изчислим маржин процент",
        tradeRules9: "Маржин процентът е мярка за риска на активите на потребителя. \nПроцент на маржин = (Нереализирана печалба и загуба + Маржин на позиция + Наличен марж + Марж за замразяване - Ликвидационна такса) / Маржин на позиция \nКолкото по-малък е маржин процентът, толкова по-висок е рискът на сметката. Когато процентът на маржин е по-малък или равен на 0%, ще се задейства принудителна ликвидация.",
        tradeRules10: "5.Каква е прогнозната цена на принудителен паритет?",
        tradeRules11: "Прогнозната цена на принудителна ликвидация, т.е. цената, изчислена от системата, която теоретично задейства принудителна ликвидация, е само за справка и може леко да се отклонява от действителната стойност.",
        tradeRules12: "6.Какво представлява общият капитал на сметката, нереализирана печалба и загуба",
        tradeRules13: "Общ капитал на сметката = баланс на сметката + нереализирана печалба и загуба\nНереализираната печалба и загуба е печалбата и загубата на позицията, която в момента се държи от потребителя във валутния договор. Нереализираната печалба и загуба ще се промени с последните промени в цената на транзакцията. \nНереализирана печалба и загуба за дълги позиции = (1/средна цена на позиция - 1/последна цена на транзакция) * брой договори за дълги позиции * номинална стойност на договора * последна цена на транзакция \n нереализирана печалба и загуба за къси позиции = (1/ последна цена на транзакция - 1/ Средна цена на позиция) * Брой къси договори * Номинална стойност на договор * Последна цена на транзакция",
        text1: "сигурност на акаунта",
        text2: "дневен и нощен режим",
        text3: "Изтрий кеш-памет",
        text4: "Сигурни ли сте, че искате да излезете?",
        text5: "Сигурни ли сте, че искате да изчистите кеша?",
        text6: "многоезичен",
        text7: "За да защитите вашата сигурност, препоръчваме да включите поне едно двуфакторно удостоверяване"
    },
    login: {
        login: "Влизам",
        register: "регистрирам",
        title1: "Търгувайте по всяко време и навсякъде и преглеждайте пазарните условия в реално време",
        title2: "Търгувайте по всяко време и навсякъде и преглеждайте пазарните условия в реално време",
        title3: "Най-доверената платформа за търговия с криптовалута",
        formTitle1: "Влизане в акаунта",
        formTitle2: "Добре дошъл обратно! Влезте с вашия имейл, телефонен номер",
        btn1: "мобилен телефон",
        btn2: "поща",
        btn3: "Влизам",
        btn4: "регистрирам",
        btn5: "забравете паролата？",
        field1: "Телефонен номер",
        field2: "парола",
        field3: "поща",
        placeholder1: "нация",
        placeholder2: "Моля, въведете телефонен номер",
        placeholder3: "Моля, въведете парола",
        placeholder4: "моля, въведете вашия имейл",
        content12: "Моля, въведете телефонен номер",
        content13: "Моля, въведете парола",
        content14: "моля, въведете вашия имейл",
        content16: "Финансови услуги за цифрови активи",
        loginSuccess: "успешен вход ",
        chooseArea: "Моля, изберете регионален код",
        placeholder5: "Моля, изберете код на държавата",
        placeholder6: "запомни паролата ми",
        placeholder7: "Изтеглете ПРИЛОЖЕНИЕ",
        placeholder8: "Свържете се с отдела за обслужване на клиенти",
        placeholder9: "Изберете държава или регион",
        placeholder10: "код на населеното място",
        placeholder11: "Вход в Wallet",
        placeholder12: "Операцията е неуспешна, моля, превключете към",
        placeholder13: "портфейл"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "относно",
        aboutCoinbeadCenterDetails: "Той има водещата в света платформа за търговия с блокчейн активи и управлява цялата екосистема.",
        footDetails1: "дневен обем на търговия",
        footDetails2: "транзакции/секунда",
        footDetails3: "Помощен център",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "Това е световноизвестен международен уебсайт за дигитални активи, основно предоставящ монети и деривати на дигитални активи като Bitcoin (BTC), Litecoin (LTC) и Ethereum (ETH) на глобални потребители.",
        coinbeadCenterDetailsm: "Възприемайки модерни технологии като GSLB, мрежови сървъри, мрежови транзакции, мрежи, многомашинни машини за високоскоростна търговия с памет, студени портфейли, интелигентни офлайн горещи портфейли и т.н., ние предоставяме на нашите клиенти множество терминали като уеб мобилни телефони и компютри , Осигурете безопасни, стабилни и надеждни цифрови тарифни транзакционни услуги. В същото време подобряваме и надграждаме продуктите и услугите въз основа на предложенията на потребителите и нуждите за предоставяне на по-добри услуги на всеки клиент и няма край на подобряването на иновативното потребителско изживяване.",
        infrastructureCenterTitle: "инфраструктура",
        infrastructureCenterDetails: "Нашата мисия е да предоставяме инфраструктурни услуги за цялата блокчейн екосистема",
        freeCenterTitle: "Безплатно",
        freeCenterDetails: "Нашата визия е да накараме парите да текат свободно по света. Вярваме, че разпространяването на тази свобода може да направи света по-добро място",
        futureCenterTitle: "Пионер в бъдещето на технологиите",
        futureCenterDetails: "Отворете бъдещето на технологиите",
    },
    applicationForListing: {
        title: "Приложение за изброяване на монети",
        projectName: "Име на проекта",
        tokenName: "Име на токена",
        projectDescription: "Описание на проекта",
        contractAddress: "Адрес на договора",
        officialWebsite: "официален сайт",
        ContactAndEmail: "Имейл за връзка",
        ContactAndName: "Име за контакт",
        file: "Качване на прикачен файл",
        pleaseEnter: "Моля, въведете",
        enterFile: "Моля, качете файлове",
        upload1: "Понастоящем ограничен до 1 избор на файл",
        upload2: "Този път аз избрах",
        upload3: "файлове",
        upload4: "Общо избрани",
        upload5: "файлове",
    },
    public: {
        submit: "Изпращане",
        copySuccessfully: "Копирано успешно",
        copyFailed: "Неуспешно копиране",
        noDate: "Няма данни",
        submitSuccessfully: "Изпратено успешно",
        goBack: "върнете се на последната страница",
        cancel: "Отказ",
        home: "първа страница",
        loading: "Зареждане...",
        confirm: "потвърди",
        loadingFailed: "мрежова аномалия",
        nomore: "няма повече",
        tryAgain: "Моля, опреснете страницата/излезте от програмата и качете отново!",
        hot: "Популярни райони",
    },
    inviteFriends: {
        inviteFriends: "Споделете с приятели",
        freedomOfWealth: "Печелившо сътрудничество",
        myInvitationCode: "моя код за покана",
        clickCopy: "Кликнете, за да копирате",
        myInvitationLink: "Линкът ми за покана",
        clicktoSaveTheQRCode: "Кликнете, за да запазите QR кода",
        saveQRCode: "QR код за покана",
        numberOfSubordinates: "Брой подчинени",
        rebateIncome: "Доход от отстъпка",
        people: "хората",
        myPromotionRevenue: "Моят промоционален доход",
        numberOfDirectSubordinates: "Брой преки подчинени",
        totalNumberOfSubordinates: "Общ брой подчинени",
        directSubordinateReturnsCommission: "Комисионна отстъпка за преки подчинени",
        theTotalCommission: "обща отстъпка",
        checkHistory: "Вижте записите за отстъпки",
        history: "Комисионен запис",
        theLowerAccount: "Подчинена сметка",
        type: "Тип：",
        serviceCharge: "такса за обработка：",
        percentageofCommissionReturned: "Коефициент на отстъпка：",
        commissionrebateAmount: "Сума на отстъпката：",
        time: "време：",
        typeName1: "Презареждане и комисионна",
        typeName2: "MT такса за обработка на поръчки тристепенно разпределение",
        typeName3: "MT печеливша тристепенна дистрибуция",
        typeName4: "Награди за препоръки",
        typeName30: "Презареждане и комисионна",
        typeName31: "Периодична отстъпка от търговската печалба",
        typeName32: "Отстъпка от печалбата при добив на ликвидност",
        typeName45: "Отстъпка от таксата за транзакция",
        typeName46: "Комисионна отстъпка върху таксата за собствена обработка",
        typeName50: "Отстъпка от таксата за обработка на договора за доставка",
        typeName51: "Постоянна отстъпка от таксата за обработка на договора",
        typeName52: "Допълнителна отстъпка от комисионната за такси за обработка на договора за доставка",
        typeName53: "Допълнителна отстъпка от комисионната за безсрочни такси за обработка на договори",
        typeName54: "Допълнителни отстъпки върху безсрочните такси за обработка на договори",
        shareRules1: "Инструкции за покана",
        shareRules2: "Влезте в центъра за покани, копирайте връзката или кода на поканата и ги споделете с приятелите си. Приятелите могат да станат ваши подчинени, като се регистрират с вашия код за покана.",
        shareRules3: "Печелете отстъпки",
        shareRules4: "Когато подчинените извършват транзакции, можете да получите съответните комисионни и се поддържат до три нива на подчинени. Например, ако поканите приятел A, A покани B и B покани C, тогава A, B и C могат да сключват договори и други транзакции на платформата и всички можете да получавате съответните комисионни.",
        shareRules5: "Отборно ниво",
        shareRules6: "Колкото повече подчинени от първо ниво повишите, толкова по-високо е нивото на екипа и толкова по-голям рабат можете да ползвате. Екипните нива са разделени на LV1-LV6, показани в таблицата по-долу, където 'N' е броят на подчинените от първо ниво, които са презаредили и са завършили удостоверяване с истинско име.",
        shareRules7: "Когато подчинените правят залози на договори за доставка, можете да получавате комисионни пропорционално на техните залози.",
        upgradeConditions: "Изискване",
        recommendedNumberOfPeople: "Препоръчителен брой хора"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "Предложения и отзиви",
        text: "Ако срещнете грешки или имате предложения за продукти по време на употреба, моля, дайте ни обратна връзка.",
        email: "имейл адрес",
        enterEmail: "Моля, въведете имейл адрес",
        enterCorrectEmail: "Моля, въведете правилния имейл адрес",
        title: "заглавие",
        enterTitle: "Моля, въведете заглавие на въпроса",
        describeTheProblem: "Опишете проблема",
        enterDescribeTheProblem: "Моля, въведете проблема, който описвате",
        submit: "Изпращане",
    },
    help: {
        enterSearch: "Търсене",
        title: "Помощен център",
        search: "Моля, въведете вашия въпрос",
        text1: "Разберете вашите нужди и продължете да ви предоставяме по-удобни услуги"
    },
    announcement: {
        enterSearch: "Търсене",
        title: "Център за съобщения",
        search: "Моля, въведете вашия въпрос"
    },
    privacy: {
        title: "Декларация за поверителност",
        content1: "1. Каква лична информация на потребителите се събира？",
        content2: "Личната информация се събира за предоставяне на продукти и услуги и за непрекъснатото им подобряване.",
        content3: "По-долу са видовете лична информация, която събираме：",
        content4: "Информация, която ни предоставяте: Ние получаваме и съхраняваме всяка информация, която предоставяте във връзка с Платформата. Можете да изберете да не предоставяте определена информация, но в резултат на това може да не можете да използвате определени „услуги на тази платформа“. Примерите за информация, която ни предоставяте, включват：",
        content5: "Име",
        content6: "адрес",
        content7: "Държава на гражданство",
        content8: "Снимка за лична карта",
        content9: "Номер на мобилен телефон/имейл номер",
        content10: "Друга информация, която ни помага да ви идентифицираме",
        content11: "Автоматично събирана информация: Ние автоматично събираме и съхраняваме определени типове информация за вашето използване на услугите на платформата, както много уебсайтове, ние използваме бисквитки и други уникални идентификатори. Ние получаваме определени видове информация, когато вашият уеб браузър или устройство осъществява достъп до Платформата. Примери за информация, която събираме и анализираме, включват：",
        content12: "Адресът на интернет протокола (IP), който свързва персонален компютър с интернет;",
        content13: "Информация за вход, имейл адрес, парола и местоположение на лично устройство или компютър;",
        content14: "Настройки на версията и часовата зона；",
        content15: "История на транзакциите.",
        content16: "Информация от други източници: Може да събираме информация за вас от други източници, като например кредитна история от кредитни бюра. Ние ще използваме тази информация за предотвратяване и откриване на измами.",
        content17: "2. Може ли да се използва от деца?",
        content18: "Тази платформа не позволява на лица под 18 години да използват „Услугата“.",
        content19: "3. За какво се използват бисквитки и други идентификатори?",
        content20: "Ние използваме бисквитки и подобни инструменти, за да оптимизираме потребителското изживяване, да предоставяме нашите услуги и да разбираме как клиентите използват нашите услуги, така че да можем да правим целеви подобрения. Ние използваме бисквитки, за да гарантираме, че нашата система може да разпознае вашия браузър или устройство и да ви предостави услуги.",
        content21: "Ние използваме оперативни бисквитки и подобни инструменти (общо „Бисквитки“), за да предоставяме услуги, като напр：",
        content22: "За да ви идентифицираме, когато влизате и използвате нашите услуги.",
        content23: "Осигурете персонализирани функции и услуги.",
        content24: "Защита срещу измамни дейности.",
        content25: "Подобрете сигурността.",
        content26: "Проследявайте вашите предпочитания (като валута и език).",
        content27: "Ние също така използваме бисквитки, за да разберем как потребителите използват нашите услуги, така че да можем да правим целеви подобрения.",
        content28: "4. Моята лична информация ще бъде ли споделена?",
        content29: "Потребителската информация е важна част от нашия бизнес и ние няма да продаваме личната информация на потребителите на други лица. Тази платформа ще споделя лична информация на потребителите със своите дъщерни дружества или филиали само при следните обстоятелства. От тези дъщерни дружества или филиали се изисква да спазват тази декларация за поверителност или поне да следват практики, които са толкова защитни, колкото и мерките за защита, описани в тази декларация за поверителност.",
        content30: "Доставчици на услуги трети страни: Ние наемаме други компании и лица да изпълняват функции от наше име. Примери за такива функции включват: анализиране на данни, предоставяне на маркетингова помощ, обработка на плащания, предаване на съдържание и оценка и управление на кредитния риск. Тези доставчици на услуги трети страни имат достъп до лична информация, необходима за изпълнение на техните функции, но не могат да я използват за други цели. Освен това те трябва да обработват лична информация в съответствие с тази декларация за поверителност и приложимите закони за защита на данните.",
        content31: "Трансфери на бизнес: Тъй като нашият бизнес продължава да расте, ние може да продаваме или купуваме други бизнеси или услуги. При такива транзакции информацията за потребителя обикновено е сред прехвърлените бизнес активи, но остава предмет на обещанията във всяка съществуваща декларация за поверителност (освен ако, разбира се, потребителят не се съгласи друго). Освен това, ако нашата компания или по същество всички нейни активи бъдат придобити, потребителската информация също ще бъде прехвърлена. Защита на нашата компания и други: Когато смятаме, че освобождаването на акаунт и друга лична информация е подходящо за спазване на закона или нашите регулаторни задължения, налагане или прилагане на нашите Условия за използване и други споразумения или правата, собствеността или безопасността на нашите потребители или други Кога ще предоставим акаунта и друга лична информация. Това включва обмен на информация с други компании и организации за защита срещу измами и намаляване на кредитния риск.",
        content32: "5. Международни трансфери на лични данни",
        content33: "Възможно е да прехвърлим вашите данни извън Европейското икономическо пространство („ЕИП“). Ние ще въведем подходящи предпазни мерки, за да гарантираме, че тези трансфери са в съответствие с приложимите правила за защита на данните, освен ако Европейската комисия не е потвърдила, че държавата, към която се трансферират данните, осигурява адекватно ниво на защита.",
        content34: "6. Безопасна ли е личната ми информация?",
        content35: "Проектирахме нашите системи с мисъл за вашата сигурност и поверителност. Ние използваме протоколи за криптиране и софтуер, за да се стремим да защитим сигурността на личната информация по време на предаване.",
        content36: "Ние винаги приемаме физически, електронни и процедурни гаранции, когато събираме, съхраняваме и разкриваме лична информация. Нашите процедури за сигурност означават, че може да се наложи да потвърдим вашата самоличност, преди да ви разкрием лична информация.",
        content37: "Най-важното нещо, което можете да направите, е да защитите паролите на личния си акаунт от неоторизиран достъп. Препоръчваме да зададете уникална парола за вашия акаунт, която да е различна от другите онлайн акаунти. И не забравяйте да излезете, след като използвате споделен компютър.",
        content38: "7. Как трябва да защитя личната информация?",
        content39: "Ако имате въпроси или възражения относно начина, по който събираме и обработваме лична информация, моля, свържете се с екипа за обслужване на клиенти",
        content40: "След като се съгласите да обработваме вашата лична информация за конкретна цел, можете да оттеглите намерението си по всяко време и ние ще спрем да обработваме вашите данни за тази цел.",
        content41: "Освен това имате право да поискате достъп до, коригиране и изтриване на лични данни и да поискате преносимост на данните в съответствие с приложимите закони. Можете също така да възразите срещу нашата обработка на вашите лични данни или да поискате нашата обработка на вашите лични данни да бъде ограничена при определени обстоятелства.",
        content42: "8. GDPR на ЕС и закон за защита на данните на Обединеното кралство – правна основа",
        content43: "GDPR на ЕС и законът за защита на данните на Обединеното кралство изискват от нас да спазваме правното основание, когато използваме лична информация. Нашата основа зависи от конкретните цели, за които се използва личната информация. Тези бази включват：",
        content44: "Изпълнение на договор - за предоставяне или комуникация с вас относно продукти или услуги, включително използването от наша страна на вашата лична информация за приемане и обработка на поръчки и обработка на плащания.",
        content45: "Нашите легитимни бизнес интереси и потребителски интереси - Ние откриваме и предотвратяваме измами и злоупотреби, за да защитим безопасността на нашите потребители, себе си или другите.",
        content46: "Вашето съгласие – ​​Изискваме вашето съгласие, за да обработваме личната ви информация за конкретните цели, съобщени ви. След като сте ни дали съгласието си да обработваме вашата лична информация за конкретна цел, можете да оттеглите съгласието си по всяко време и ние ще спрем да обработваме вашите данни за тази цел.",
        content47: "Спазване на законови задължения - Ние използваме вашата лична информация, както се изисква от закона. Например, ние събираме информация за банкова сметка за целите на проверка на самоличността.",
        content48: "Горните и други правни основания зависят от конкретните цели, за които използваме личната информация.",
        content49: "9. Условия за използване, бележки и изменения",
        content50: "Вашето използване и всеки спор относно поверителността е предмет на настоящата Декларация и нашите Условия за ползване. Ако имате някакви притеснения относно поверителността на тази платформа, моля, свържете се с нас с подробно обяснение и ние ще се радваме да разрешим проблема ви. Също така имате право да се свържете с местния орган за защита на данните.",
        content51: "Нашият бизнес непрекъснато се променя, както и нашата декларация за поверителност. Трябва често да проверявате нашия уебсайт, за да видите последните промени. Ако не сте съгласни с ревизираното съдържание, трябва незабавно да спрете достъпа. След публикуването на актуализираната версия на Политиката за поверителност, вашият продължителен достъп означава, че сте съгласни с актуализираното съдържание и се съгласявате да спазвате актуализираната Политика за поверителност. Освен ако не е посочено друго, настоящата Декларация за поверителност се прилага за цялата информация, която съхраняваме за вас и вашия акаунт.",
    },
    serviceAgreement: {
        title: "Споразумение за обслужване",
        content1: "Този уебсайт е платформа специално за потребителите за извършване на транзакции с цифрови активи и предоставяне на свързани услуги (наричани по-долу „услугата“ или „услугата“). За удобство при описване на това споразумение, този уебсайт колективно използва „ние“ или други местоимения от първо лице в това споразумение. Докато физическото лице или друг субект, който влиза в уебсайта, е потребител на този уебсайт, за удобство при изразяване на това съгласие по-долу ще се използва „вие“ или друго второ лице. За удобство на изразяване на това Споразумение, ние и вие се наричаме колективно „Страните“ в това Споразумение, а ние или Вие се наричаме индивидуално „Страна“.",
        content2: "важен намек：",
        content3: "Бихме искали да ви напомним тук：",
        content4: "1 Самите цифрови активи не се издават от никоя финансова институция или компания или този уебсайт",
        content5: "2 Пазарите на цифрови активи са нови, непотвърдени и може да не растат；",
        content6: "3 Дигиталните активи се използват широко от спекулантите, с относително малко използване на пазарите на дребно и търговските транзакции, които са изключително рискови производители и глобални правителствени политики；",
        content7: "4  Компанията си запазва правото да спре или прекрати вашия акаунт по всяко време, ако Компанията установи, по свое усмотрение, че сте нарушили това Споразумение или че услугите, предоставяни от този уебсайт, или използването на услугите, предоставяни от този уебсайт, са незаконни съгласно законите на вашата юрисдикция или да спрете или прекратите използването на услугите или транзакциите с цифрови активи, предоставени от този уебсайт. На всеки от [континентален Китай, Тайван, Израел, Ирак, Бангладеш, Боливия, Еквадор, Киргизстан, Севастопол и Обединеното кралство (потребители на дребно)] е забранено да използва услугите за договорни транзакции, предоставяни от този уебсайт. Горепосоченият списък с държави или региони ще се промени в зависимост от политиките и видовете продукти на различните държави или региони. Може да не ви уведомим конкретно в този момент, така че, моля, обръщайте внимание на актуализациите на това споразумение своевременно.",
        content8: "Търговията с цифрови активи носи изключително високи рискове и не е подходяща за повечето хора. Разбирате и разбирате, че тази транзакция може да доведе до частична или пълна загуба, така че трябва да определите сумата на транзакцията въз основа на степента на загуба, която можете да си позволите. Вие знаете и разбирате, че цифровите активи ще генерират производни рискове, така че ако имате някакви въпроси, се препоръчва първо да потърсите помощта на професионални съветници. Освен това, в допълнение към рисковете, споменати по-горе, ще има и рискове, които не могат да бъдат предвидени. Трябва внимателно да обмислите и да използвате ясна преценка, за да оцените финансовото си състояние и гореспоменатите рискове, преди да вземете решение за покупка или продажба на цифрови активи, и да поемете всички произтичащи от това загуби. Ние не поемаме никаква отговорност за това.",
        content9: "Предупреждение за вас：",
        content10: "1 Вие разбирате, че този уебсайт се използва само като място за получаване на информация за цифрови активи, намиране на страни по транзакции, преговори и извършване на транзакции с цифрови активи. Този уебсайт не участва в нито една от вашите транзакции, така че трябва да използвате собствената си разумна преценка за определяне на съответните цифрови активи и/или транзакции или автентичността, законността и валидността на информацията и ще поеме произтичащите от това отговорности и загуби.",
        content11: "2 Всички мнения, новини, дискусии, анализи, цени, препоръки и друга информация на този уебсайт са общи пазарни коментари и не представляват инвестиционен съвет. Ние не носим отговорност за загуби, произтичащи пряко или косвено от разчитането на тази информация, включително, но не само, пропуснати ползи.",
        content12: "3 Този уебсайт си запазва правото да вземе собствено решение, да модифицира или промени съдържанието по всяко време. Ние сме взели разумни мерки, за да гарантираме точността на информацията на уебсайта, но не можем да гарантираме нейната точност и няма да носим отговорност за това. всякакви загуби или щети, причинени от информацията на този уебсайт или липсата на информация, произтичащи от закъснения или неуспехи при свързване към интернет, предаване или получаване на известия и информация.",
        content13: "4 Съществуват и рискове при използването на интернет базирани системи за търговия, включително, но не само, повреди на софтуера, хардуера и интернет връзката. Тъй като нямаме контрол върху надеждността и наличността на интернет, ние не поемаме отговорност за изкривяване, забавяне и прекъсване на връзката.",
        content14: "5 Забранено е използването на този уебсайт за извършване на всякакви незаконни търговски дейности или незаконни дейности като пране на пари, контрабанда, търговски подкупи и т.н. Ако бъдат открити предполагаеми незаконни транзакции или незаконни дейности, този уебсайт ще използва различни налични средства, включително но не се ограничава до замразяване на сметки и уведомяване на съответните органи и т.н., ние не поемаме всички произтичащи от това отговорности и си запазваме правото да търсим отговорност от съответните лица.",
        content15: "6 Забранено е използването на този уебсайт за злонамерено манипулиране на пазара, неправилни транзакции и други неетични търговски дейности. Ако бъдат открити такива инциденти, този уебсайт ще предупреди, ще ограничи транзакциите и ще затвори всяко неетично поведение, като злонамерено манипулиране на цените и злонамерено влияние върху търговска система не поема цялата отговорност, произтичаща от превантивни мерки за защита, като спиране на сметката, и си запазва правото да търси отговорност от съответните лица.",
        content16: "1. Общи принципи",
        content17: "1.1 Потребителско споразумение (наричано по-нататък „това Споразумение“ или „Тези Правила и условия“) се състои от основния текст, „Условия за поверителност“, „Познайте своя клиент и Политика срещу изпирането на пари“ и различни други политики, които са са публикувани или могат да бъдат публикувани в бъдеще на този уебсайт, правила, изявления, описания и др.",
        content18: "1.2 Преди да използвате услугите, предоставяни от този уебсайт, моля, прочетете внимателно това споразумение. Ако не разбирате или имате някаква друга ситуация, моля, консултирайте се с професионален адвокат. Ако не сте съгласни с това споразумение, моля, спрете да го използвате. След като влезете в този уебсайт, използвате този уебсайт за извършване на услуги или други подобни действия, вие разбирате и напълно се съгласявате с всички промени, направени в това Споразумение.",
        content19: "1.3 Можете да станете член на този уебсайт (наричан по-долу „член“), като попълните съответната информация в съответствие с изискванията на този уебсайт и се регистрирате успешно след други съответни процедури, като щракнете върху бутона „Съгласен съм“ по време на регистрацията обработвате, подписвате по електронен път формуляр за споразумение с компанията или когато щракнете върху който и да е бутон, отбелязан с „Съгласен“ или подобно значение по време на използването на този уебсайт, или действително използвате услугите, предоставяни от този уебсайт по други начини, разрешени от този уебсайт; , това означава, че вие ​​напълно разбирате, съгласни сте и приемате всички условия по това споразумение.",
        content20: "1.4 След като станете член на този уебсайт, вие ще получите членски акаунт и съответната парола, които се пазят от вас;",
        content21: "1.5 Само членове, които станат членове на този уебсайт, могат да използват платформата за търговия с цифрови активи, предоставена от този уебсайт, за транзакции и да се възползват от други услуги, предвидени от този уебсайт, които са достъпни само за членове; лицата, които не са членове, могат само да влизат в уебсайта, да разглеждат уебсайта и други услуги, предвидени от този уебсайт.",
        content22: "1.6 Като се регистрирате и използвате всички услуги и функции, предоставени от този уебсайт, ще се счита, че сте прочели, разбрали и:",
        content23: "1.6.1 Приемам да се обвържа с всички правила и условия на това Споразумение.",
        content24: "1.6.2 Вие потвърждавате, че сте навършили 18 години или имате законовата възраст за сключване на договори съгласно различни приложими закони. Вашата регистрация на този уебсайт, продажби или покупки, публикуване на информация и т.н. и приемането на услугите на този уебсайт трябва да са в съответствие. с вашите изисквания. Имате юрисдикция над съответните закони и разпоредби на суверенна държава или регион и имате пълната възможност да приемате тези условия, да сключвате транзакции и да използвате този уебсайт за извършване на транзакции с цифрови активи.",
        content25: "1.6.3 Вие гарантирате, че всички цифрови активи, които ви принадлежат, участващи в транзакцията, са законно получени и притежават собственост.",
        content26: "1.6.4 Вие се съгласявате, че носите цялата отговорност за вашите собствени търговски или нетърговски дейности и за всякакви печалби или загуби.",
        content27: "1.6.5 Вие потвърждавате, че информацията, която предоставяте при регистрацията е вярна и точна.",
        content28: "1.6.6 Вие се съгласявате да спазвате изискванията на всеки приложим закон, включително за данъчни цели, включително отчитане на всякакви печалби от търговия.",
        content29: "1.6.7 Вие се съгласявате да не участвате или да не участвате в поведение или дейности, които вредят на интересите на този уебсайт или компанията по всяко време, независимо дали са свързани или не с услугите, предоставяни от този уебсайт.",
        content30: "1.6.8 Това споразумение урежда само правата и задълженията между вас и нас и не включва правни отношения и правни спорове, произтичащи от транзакции с цифрови активи между потребителите на този уебсайт и други уебсайтове и вас.",
        content31: "2. Промени в споразумението",
        content32: "Запазваме си правото да преразглеждаме това Споразумение от време на време и да го обявяваме на уебсайта, без да ви уведомяваме отделно. След преразглеждането времето за преразглеждане ще бъде отбелязано в [Време за последна актуализация], показано в това Споразумение, и автоматично ще отнеме. ефект след публикуването му на уебсайта. Трябва да разглеждате и да обръщате внимание на времето за актуализиране и актуализираното съдържание от време на време. Ако не сте съгласни със съответните промени, трябва незабавно да спрете да използвате услугите на този уебсайт; уебсайт означава, че приемате и се съгласявате да бъдете обвързани от преработеното споразумение.",
        content33: "3. Регистрация",
        content34: "3.1 Квалификации за регистрация",
        content35: "Вие потвърждавате и обещавате, че когато завършите процеса на регистрация или действително използвате услугите, предоставяни от този уебсайт по други начини, разрешени от този уебсайт, трябва да имате възможността да подпишете това споразумение и да използвате услугите на този уебсайт, както е предвидено от приложимите закони. физическо лице, юридическо лице или друга организация. След като щракнете върху бутона „Съгласен съм да се регистрирам“, това означава, че вие ​​или вашият упълномощен агент сте се съгласили със съдържанието на споразумението и сте регистрирани и сте използвали услугите на този уебсайт от неговия агент. Ако нямате гореспоменатите квалификации, вие и вашият упълномощен агент ще понесете всички произтичащи от това последици и компанията си запазва правото да анулира или замрази завинаги вашия акаунт и да държи вас и вашия упълномощен агент отговорни.",
        content36: "3.2 Целта на регистрацията",
        content37: "Вие потвърждавате и обещавате, че вашата регистрация на този уебсайт не е с цел нарушаване на закони и разпоредби или нарушаване на реда на транзакции с цифрови активи на този уебсайт.",
        content38: "3.3 процес на регистрация",
        content39: "3.3.1 Вие се съгласявате да предоставите валиден имейл адрес, мобилен телефонен номер и друга информация, както се изисква на страницата за регистрация на потребителя на този уебсайт. Можете да използвате имейл адреса, мобилния телефонен номер, който сте предоставили или потвърдили, или други методи, разрешени от този уебсайт, като вход метод за влизане в този уебсайт. Ако е необходимо, в съответствие със съответните закони и разпоредби на различни юрисдикции, трябва да предоставите истинското си име, документ за самоличност и друга подходяща информация, предвидена в законите и разпоредбите, клаузите за поверителност и клаузите срещу прането на пари, и постоянно да актуализирате информацията за регистрация в навременен, подробен и точен начин. Цялата първоначално въведена информация ще бъде посочена като информация за регистрация. Вие носите отговорност за автентичността, пълнотата и точността на тази информация и ще поемете всички преки или косвени загуби и неблагоприятни последици, произтичащи от това.",
        content40: "3.3.2 Ако законите, разпоредбите, правилата, заповедите и другите разпоредби на суверенната държава или регион, където се намирате, имат изисквания за реално име за мобилни телефонни номера, вие се съгласявате, че предоставеният регистриран мобилен телефонен номер е регистриран с истинско име не го предоставите в съответствие с разпоредбите, всички причинени за вас последствия ще бъдат Преки или косвени загуби и неблагоприятни последици ще се поемат от вас.",
        content41: "3.3.3 Ако предоставите информацията, необходима за регистрация законно, напълно и ефективно и сте я потвърдили, имате право да получите номера на акаунта и паролата на този уебсайт, когато получите номера на акаунта и паролата на този уебсайт, вашата регистрация се счита за извършена успешно и можете да влезете като член на този уебсайт.",
        content42: "3.3.4 Вие се съгласявате да получавате имейли и/или кратки съобщения, изпратени от този уебсайт, свързани с управлението и работата на този уебсайт.",
        content43: "4. Обслужване",
        content44: "Този уебсайт предоставя само услуги на платформа за онлайн търговия за вашите дейности по търговия с цифрови активи (включително, но не само търговия с цифрови активи и други услуги) чрез този уебсайт.",
        content45: "4.1 Съдържание на услугата",
        content46: "4.1.1 Имате право да преглеждате пазарните условия в реално време и информацията за транзакциите на различни продукти с цифрови активи на този уебсайт и имате право да изпращате инструкции за транзакции с цифрови активи и да извършвате транзакции с цифрови активи чрез този уебсайт.",
        content47: "4.1.2 Имате право да преглеждате информацията във вашия членски акаунт на този уебсайт и да прилагате функциите, предоставени от този уебсайт, за да работите.",
        content48: "4.1.3 Имате право да участвате в дейности на уебсайта, организирани от този уебсайт в съответствие с правилата за дейност, публикувани на този уебсайт.",
        content49: "4.1.4 Този уебсайт обещава да ви предостави и други услуги.",
        content50: "4.2 Правила за обслужване Вие обещавате да спазвате следните правила за обслужване на този уебсайт：",
        content51: "4.2.1 Вие трябва да спазвате законите, разпоредбите и изискванията на политиката, да гарантирате законността на източниците на всички цифрови активи във вашия акаунт и да не участвате в незаконни или други дейности, които увреждат правата и интересите на този уебсайт или трети страни на този уебсайт или чрез използване на неговите услуги, включително, но не само: Вие не сте ограничени до изпращане или получаване на незаконна, незаконна или нарушаваща правата на други информация информация, изпращане или получаване на пирамидални схеми или друга вредна информация или забележки, използване или фалшифициране на имейл заглавна информация на този уебсайт без разрешение от този уебсайт и др.",
        content52: "4.2.2 Трябва да спазвате законите и разпоредбите и правилно да използвате и пазите номера на сметката си, паролата за влизане, паролата за фонд, мобилния телефонен номер, свързан с вас при регистрация, и кода за потвърждение на мобилния телефон, получен от вашия мобилен телефон. Вие носите пълна отговорност за всички операции и последствия от използването на вашия акаунт и парола за вход, парола за фонд и код за потвърждение на мобилен телефон. Когато установите, че номерът на акаунта, паролата за влизане или паролата за фонд или кодът за потвърждение на този уебсайт се използват от трета страна без ваше разрешение или има други проблеми със сигурността на акаунта, трябва незабавно и ефективно да уведомите този уебсайт и да поискате този уебсайт да бъде спрян услугата на акаунта на този уебсайт. Този уебсайт има правото да предприеме действия по вашето искане в рамките на разумен срок, но този уебсайт не носи никаква отговорност за последствията (включително, но не само претърпените от вас загуби), които са настъпили преди предприемането на действия. Нямате право да дарявате, заемате, давате под наем, прехвърляте или по друг начин да се разпореждате с вашия акаунт на този уебсайт на други лица без съгласието на този уебсайт.",
        content53: "4.2.3 Вие се съгласявате да носите отговорност за всички дейности, които се извършват под вашия акаунт и парола на този уебсайт (включително, но не само, разкриване на информация, публикуване на информация, онлайн кликвания за съгласие или подаване на различни правила и споразумения, онлайн подновяване на споразумения или закупуване на услуги и др.).",
        content54: "4.2.4 Когато извършвате транзакции с цифрови активи на този уебсайт, не трябва злонамерено да се намесвате в нормалния ход на транзакциите с цифрови активи или да нарушавате реда на транзакциите; не трябва да се намесвате в нормалната работа на този уебсайт или да пречите на използването на този уебсайт от други потребители услуги с каквито и да е технически средства или други средства, не трябва да използвате фиктивни злонамерени злонамерени репутации на този уебсайт чрез факти и други средства.",
        content55: "4.2.5 Ако имате спор с други потребители поради онлайн транзакции, не можете да поискате от този уебсайт да предостави подходяща информация по несъдебни или административни канали.",
        content56: "4.2.6 Вие сами преценявате и поемате всички дължими данъци, както и всички хардуерни, софтуерни, сервизни и други разходи, направени по време на използването на услугите, предоставяни от този уебсайт.",
        content57: "4.2.7 Трябва да спазвате това споразумение и други условия на услугата и правила за работа, публикувани и актуализирани от този уебсайт от време на време, и имате право да прекратите използването на услугите, предоставяни от този уебсайт по всяко време.",
        content58: "4.3 продуктови правила",
        content59: "4.3.1 Прегледайте информацията за транзакцията",
        content60: "Когато преглеждате информация за транзакция на този уебсайт, трябва внимателно да прочетете цялото съдържание, съдържащо се в информацията за транзакция, включително, но не само цена, обем на комисионната, такса за обработка, посока за покупка или продажба, и само след като напълно приемете цялото съдържание, съдържащо се в информацията за транзакцията Сделките могат да се извършват с едно натискане на бутон.",
        content61: "4.3.2 Вижте подробности за транзакцията",
        content62: "Можете да видите съответните записи за транзакции през вашия акаунт.",
        content63: "5. Права и задължения на този уебсайт",
        content64: "5.1 Ако нямате квалификациите за регистрация, предвидени в това споразумение, този уебсайт има право да откаже регистрацията ви. За тези, които вече са се регистрирали, този уебсайт има право да анулира вашия акаунт за членство вашият упълномощен агент носи отговорност. В същото време този уебсайт си запазва правото да реши дали да приеме вашата регистрация при всякакви други обстоятелства.",
        content65: "5.2 Въз основа на собствената преценка на този уебсайт, ако този уебсайт установи, че вие ​​или свързаните с вас потребители на акаунти не сте подходящи за високорискови инвестиции, ние имаме право да спрем или прекратим вашия акаунт и използването на всички свързани акаунти.",
        content66: "5.3 Когато този уебсайт открие, че потребителят на акаунта не е първоначалният регистрант на акаунта, той има право да спре или прекрати използването на акаунта.",
        content67: "5.4 Когато този уебсайт основателно подозира, че предоставената от вас информация е грешна, невярна, невалидна или непълна чрез технически тестове, ръчно вземане на проби и други методи за тестване, той има правото да ви уведоми, за да коригира или актуализира информацията или да спре или прекрати предоставянето на този уебсайт ви обслужва.",
        content68: "5.5 Този уебсайт си запазва правото да коригира всяка информация, показана на този уебсайт, ако се установи, че има очевидна грешка.",
        content69: "5.6 Този уебсайт си запазва правото да променя, прекратява или прекратява услугите на този уебсайт по всяко време уебсайт, прекратяването ще бъде от този уебсайт на уебсайта, в сила от датата на публикуване на съобщението за прекратяване.",
        content70: "5.7 Този уебсайт ще предприеме необходимите технически средства и мерки за управление, за да осигури нормалната работа на този уебсайт, да осигури необходимата и надеждна търговска среда и услуги за търговия и да поддържа реда на транзакциите с цифрови активи.",
        content71: "5.8 Ако не влезете в този уебсайт, като използвате своя членски акаунт и парола за една последователна година, този уебсайт има право да анулира вашия акаунт. След като акаунтът бъде анулиран, този уебсайт има право да отвори съответното име на член за други потребители за регистрация и използване.",
        content72: "5.9 Този уебсайт гарантира сигурността на вашите цифрови активи чрез укрепване на технологичните инвестиции, подобряване на предпазните мерки за сигурност и други мерки и ще ви уведомява предварително, когато възникнат предвидими рискове за сигурността във вашия акаунт.",
        content73: "5.10 Този уебсайт има право да изтрие всякакъв вид информация за съдържанието на този уебсайт, която не е в съответствие със законите и разпоредбите на този уебсайт, по всяко време не е необходимо да ви уведомява предварително, за да упражнява тези права.",
        content74: "5.11 Този уебсайт има право да поиска от вас да предоставите повече информация или материали в съответствие със законите, разпоредбите, правилата, заповедите и другите регулаторни изисквания на вашата суверенна държава или регион и да предприеме разумни мерки за спазване на местните регулаторни изисквания са длъжни да сътрудничат; уебсайтът има право да спре или завинаги да ви отваря някои или всички услуги на този уебсайт в съответствие с изискванията на законите, разпоредбите, правилата, заповедите и други спецификации на вашата суверенна държава или регион.",
        content75: "5.12 Този уебсайт си запазва правото да закрие вашия акаунт след предизвестие от седем работни дни по свое усмотрение. Следователно имате седем работни дни за анулиране на поръчки и затваряне на позиции. Ако не сте анулирали поръчката и не сте затворили позицията, когато периодът изтече, ние принудително ще анулираме поръчката и ще затворим позицията и ще ви върнем останалите цифрови активи в акаунта ви.",
        content76: "5.13 С цел защита на правата и интересите на търговците, този уебсайт има право да прави корекции на онлайн продукти при специални обстоятелства (като повреда на системата, повреда на мрежата, екстремни пазарни условия и др.), като например: договори за ранна доставка и сетълмент, видове договори и договори за ранна доставка и период на сетълмент и цена на доставка са предмет на обявяване на този уебсайт.",
        content77: "6. Обезщетение",
        content78: "6.1 В никакъв случай нашата отговорност към вас за преки щети няма да надвишава общите такси за обслужване, които сме ви начислили за вашето използване на този уебсайт за период от три (3) месеца.",
        content79: "6.2 Ако нарушите това Споразумение или други закони и разпоредби, трябва да ни компенсирате най-малко 2 милиона щатски долара и да поемете всички направени разходи (включително адвокатски хонорари и т.н.), трябва да направите за това.",
        content80: "7. Право да се търси мярка за неотклонение",
        content81: "И ние, и вие признаваме, че средствата за правна защита по обичайното право за нарушение на договора или евентуално нарушение на договора може да не са достатъчни, за да компенсират всички загуби, които понасяме, така че имаме право да търсим съдебна забрана, както е разрешено от общото право или справедливостта в в случай на нарушение на договора или евентуално нарушение на договора, всички други средства за защита.",
        content82: "8. Ограничение на отговорността и отказ от отговорност",
        content83: "8.1 Вие разбирате и се съгласявате, че при никакви обстоятелства ние няма да носим отговорност за следните въпроси：",
        content84: "8.1.1 загуба на доходи；",
        content85: "8.1.2 Търговски печалби или загуби по договори；",
        content86: "8.1.3 Загуби, причинени от прекъсване на дейността；",
        content87: "8.1.4 Загуба на очаквани парични спестявания；",
        content88: "8.1.5 Загуби, причинени от информационни проблеми；",
        content89: "8.1.6 Загуба на възможност, добра воля или репутация；",
        content90: "8.1.7 Повреда или загуба на данни；",
        content91: "8.1.8 Разходи за закупуване на заместващи продукти или услуги；",
        content92: "8.1.9 Всички непреки, специални или случайни загуби или щети, произтичащи от правонарушение (включително небрежност), нарушение на договора или друга причина, независимо дали такава загуба или щета е разумно предвидима от нас, независимо дали сме били информирани за съществуването на такива предварително Възможност за загуба или повреда.",
        content93: "8.1.1 Членове към 8.1.9 са независими един от друг.",
        content94: "8.2 Вие разбирате и се съгласявате, че ние няма да носим отговорност за каквито и да било щети, причинени на вас от някое от следните обстоятелства:：",
        content95: "8.2.1 Вашите конкретни транзакции може да включват големи нарушения на законите или нарушения на договора.",
        content96: "8.2.2 Вашето поведение на този уебсайт може да е незаконно или неетично.",
        content97: "8.2.3 Разходи и загуби, възникнали при закупуване или получаване на данни, информация или извършване на транзакции чрез услугите на този уебсайт или чрез заместващи действия.",
        content98: "8.2.4 Вашето неразбиране относно услугите на този уебсайт.",
        content99: "8.2.5 Всички други загуби, свързани с услугите, предоставяни от този уебсайт, които не са причинени от нас.",
        content100: "8.3 Ние сме отговорни за поддръжката на информационно мрежово оборудване, повреда на връзката с информационна мрежа, повреда на компютър, комуникационна или друга система, повреда в електрозахранването, метеорологични условия, аварии, стачки, трудови спорове, бунтове, въстания, бунтове, недостатъчна производителност или производствени материали, пожар, наводнения , бури, експлозии, войни, банкови или други партньорски причини, срив на пазара на цифрови активи, действия на правителството, разпореждания на съдебни или административни агенции, други действия, които са извън нашия контрол или които нямаме възможност да контролираме, или причини на трети страни Ние не поемайте никаква отговорност за невъзможността или забавянето на услугата или вашите загуби.",
        content101: "8.4 Не можем да гарантираме, че цялата информация, програми, текстове и т.н., съдържащи се в този уебсайт, са напълно безопасни и няма да бъдат повлияни и унищожени от каквито и да било вируси, троянски коне и други злонамерени програми, следователно, ако влезете и използвате каквито и да било услуги този уебсайт или изтегляне и използване на изтеглени програми, информация, данни и т.н. са изцяло ваши собствени решения и вие поемате рисковете и възможните загуби на свой собствен риск.",
        content102: "8.5 Ние не поемаме никакви гаранции или ангажименти относно каквато и да е информация, продукти и услуги на уебсайтове на трети страни, свързани с този уебсайт, или друга форма на съдържание, което не ни принадлежи, ако използвате услуги, информация и услуги, предоставени от трети страни -уебсайтовете на страните, продуктите и т.н. са изцяло ваши собствени решения и вие носите всички отговорности, произтичащи от това.",
        content103: "8.6 Ние не даваме изрични или подразбиращи се гаранции за вашето използване на услугите на този уебсайт, включително, но не само, пригодността на услугите, предоставяни от този уебсайт, липса на грешки или пропуски, непрекъснатост, точност, надеждност и пригодност за конкретен предназначение. В същото време ние не поемаме никакви ангажименти или гаранции по отношение на валидността, точността, коректността, надеждността, качеството, стабилността, пълнотата и навременността на технологията и информацията, включени в услугите, предоставяни от този уебсайт. Дали да влезете или да използвате услугите, предоставяни от този уебсайт, е ваше лично решение и вие поемате собствените си рискове и евентуални загуби. Ние не даваме изрични или подразбиращи се гаранции по отношение на пазара, стойността и цената на цифровите активи. Вие разбирате, че пазарът на цифрови активи може да се колебае или да се срине значително по всяко време вашата лична свобода. Вие избирате и решавате на свой собствен риск и възможни загуби.",
        content104: "8.7 Нашите гаранции и ангажименти, посочени в това Споразумение, са единствените гаранции и изявления, направени от нас във връзка с това Споразумение и услугите, предоставени на този уебсайт, и заместват всички гаранции и ангажименти, произтичащи по друг начин и начин, независимо дали са писмени или устни, изрични на или подразбиращи се. Всички тези гаранции и изявления представляват само нашите собствени ангажименти и гаранции и не гарантират, че трета страна ще спазва гаранциите и ангажиментите в това Споразумение.",
        content105: "8.8 Ние не се отказваме от никакви права, които не са споменати в това Споразумение, за ограничаване, изключване или компенсиране на нашата отговорност за щети в най-пълната степен на приложимото законодателство.",
        content106: "8.9 След като се регистрирате, вие се съгласявате с всички операции, които извършваме в съответствие с правилата, посочени в това споразумение, и всички поети рискове се поемат от вас.",
        content107: "9. Прекратяване на споразумението",
        content108: "9.1 Този уебсайт има право да прекрати всички услуги на този уебсайт в съответствие с това споразумение Това споразумение ще бъде прекратено на датата, на която всички услуги на този уебсайт бъдат прекратени.",
        content109: "9.2 След прекратяването на това Споразумение нямате право да изисквате този уебсайт да продължи да му предоставя каквито и да е услуги или да изпълнява каквито и да е други задължения, включително, но не само изискването този уебсайт да запази или разкрие пред вас каквато и да е информация в първоначалния си акаунт на уебсайта на вас или трета страна препраща информация, която не е прочела или изпратила.",
        content110: "9.3 Прекратяването на това споразумение няма да засегне другите отговорности на ненарушилата страна спрямо нарушилата страна.",
        content111: "10. Права на интелектуална собственост",
        content112: "10.1 Всички интелектуални постижения, съдържащи се в този уебсайт, включват, но не се ограничават до лога на уебсайтове, бази данни, дизайн на уебсайтове, текст и графики, софтуер, снимки, видеоклипове, музика, звуци и комбинации от тях, софтуерни компилации, свързани изходни кодове и софтуер (включително малки приложения ) Правата на интелектуална собственост на програми и скриптове) принадлежат на този уебсайт. Нямате право да възпроизвеждате, променяте, копирате, изпращате или използвате който и да е от горепосочените материали или съдържание за търговски цели.",
        content113: "10.2 Всички права, съдържащи се в името на този уебсайт (включително, но не само, репутация и търговски марки, лога) принадлежат на компанията.",
        content114: "10.3 Вашето приемане на това споразумение ще се счита за ваша инициатива за прехвърляне на авторските права върху всякаква форма на информация, която публикувате на този уебсайт, включително, но не само: права за възпроизвеждане, права за разпространение, права за отдаване под наем, права за изложби, права за представяне, права за показване, права за излъчване, права за предаване на информация по интернет, права за заснемане, права за превод, права за компилация и други прехвърляеми права, които трябва да се ползват от притежателя на авторските права, се прехвърлят изключително безплатно на този уебсайт. Този уебсайт има право да подава независими съдебен иск срещу всеки субект за нарушение и получаване на пълно обезщетение. Това споразумение е валидно за всяко работно съдържание, защитено от закона за авторското право, което публикувате на този уебсайт, независимо дали съдържанието е формирано преди подписването на това споразумение или след подписването на това споразумение.",
        content115: "10.4 Нямате право да използвате незаконно или да се разпореждате с правата на интелектуална собственост на този уебсайт или други, когато използвате услугите на този уебсайт. Нямате право да публикувате или упълномощавате други уебсайтове (и медии) да използват информацията, публикувана на този уебсайт под каквато и да е форма.",
        content116: "11. Защита на информацията",
        content117: "Разпоредбите на „Условията за поверителност“, публикувани отделно на този уебсайт, имат предимство.",
        content118: "12. Изчисляване",
        content119: "Всички резултати от изчисленията на транзакциите са проверени от нас и всички методи за изчисление са публикувани на уебсайта, но не можем да гарантираме, че използването на уебсайта няма да бъде прекъснато или без грешки.",
        content120: "13. Експортен контрол",
        content121: "Вие разбирате и потвърждавате, че съгласно съответните закони не ви е позволено да експортирате, реекспортирате, импортирате или прехвърляте каквито и да е материали (включително софтуер) на този уебсайт, така че гарантирате, че няма активно да прилагате, подпомагате или участвате в който и да е от гореспоменатия износ или свързани дейности, които нарушават законите и разпоредбите за прехвърляне или други нарушения на приложимите закони и разпоредби, ако бъде открита такава ситуация, трябва да ни докладвате активно за това и да ни помогнете да се справим с нея.",
        content122: "14. Трансфер",
        content123: "Правата и задълженията, предвидени в този Договор, обвързват и правоприемниците, наследниците, изпълнителите и администраторите на страните, които се ползват от тези права и задължения. Не можете да го прехвърляте на трета страна без нашето съгласие, но ние можем да прехвърлим правата и задълженията си в това Споразумение на трета страна по всяко време и да ви уведомим.",
        content124: "15. Делимост",
        content125: "Ако която и да е клауза на това Споразумение бъде счетена за неприложима, невалидна или незаконна от който и да е компетентен съд, това няма да повлияе на валидността на останалите клаузи на това Споразумение.",
        content126: "16. Неагентска връзка",
        content127: "Нищо в това Споразумение не трябва да се счита, че създава, предполага или по друг начин ни конституира като ваш агент, попечител или друг представител, освен ако не е предвидено друго в това Споразумение.",
        content128: "17. Въздържане",
        content129: "Отказът от наша или ваша страна от отговорността на която и да е страна за нарушение на договора или друга отговорност, предвидена в това Споразумение, няма да се счита или тълкува като отказ от друга отговорност за нарушение на договора; неупражняването на което и да е право или средство за защита няма да се счита за такова начин да се тълкува като отказ от такива права или средства за защита.",
        content130: "18. Заглавие",
        content131: "Всички заглавия са само за удобство при изразяване на споразумението и не се използват за разширяване или ограничаване на съдържанието или обхвата на условията на споразумението.",
        content132: "19. Приложимо право",
        content133: "19.1 Преди да повдигнете спор или иск, вие потвърждавате и се съгласявате да се свържете с този уебсайт неофициално, за да разрешите спора възможно най-скоро; двете страни се съгласяват да разрешат спора чрез преговори на добра воля са поверителни и защитени от приложимите правила и не се използват като доказателство в никакви съдебни производства).",
        content134: "19.2 Вие потвърждавате и се съгласявате, че в случай на спор, противоречие, несъгласие или иск, включително съществуването, валидността, тълкуването, изпълнението, нарушението или прекратяването на тези Условия или всеки спор, произтичащ от или във връзка с тези Условия („Спор“ ) , гореспоменатите страни ще отнесат спора до Международния арбитражен съд на Международната търговска камара („Международен арбитражен съд на ICC“) в съответствие с тогавашните „Арбитражни правила на ICC“. Мястото на арбитража е Белиз и приложимото право на арбитража се определя в съответствие с арбитражните правила на Международната търговска камара. Освен ако страните не са договорили друго, само един арбитър ще бъде назначен съгласно Правилата за арбитраж на ICC. Арбитърът има изключителни правомощия да се произнася по своята собствена юрисдикция, включително, без ограничение, всяко възражение срещу съществуването, обхвата или валидността на арбитражното споразумение или арбитражността на всеки иск или насрещен иск. Всеки арбитраж ще се проведе на английски език. Независимо от това как се провежда арбитражът, арбитърът издава писмено решение, което е разумно и достатъчно, за да обясни решението и основните заключения, ако има такива, на които се основава решението. Арбитражното решение е окончателно и задължително за страните и може да бъде изпълнено във всеки компетентен съд.",
        content135: "20. Ефективност и тълкуване на споразумението",
        content136: "20.1 Това споразумение влиза в сила, когато щракнете върху страницата за регистрация на този уебсайт, за да се съгласите да се регистрирате, да завършите процеса на регистрация и да получите акаунт и парола за този уебсайт, и е обвързващо както за този уебсайт, така и за вас.",
        content137: "20.2 Правото на окончателното тълкуване на това споразумение принадлежи на този уебсайт.",
        content138: "Познайте своите клиенти и политиката за борба с прането на пари",
        content139: "1. Въведение",
        content140: "1.1 Обещаваме внимателно да спазваме законите и разпоредбите, свързани с „Познавайте своя клиент“ и борбата с прането на пари и няма да нарушаваме умишлено „Политиката за познаване на клиента и борбата с прането на пари“. В рамките на нашия разумен контрол ние ще предприемем необходимите мерки и технологии, за да ви предоставим безопасни услуги и да ви предпазим от загуби, причинени от поведението на заподозрени в престъпления пране на пари, доколкото е възможно.",
        content141: "1.2 Нашата Политика „Познай своя клиент“ и политика срещу изпирането на пари е всеобхватна международна система от политики, която включва политики „Познай своя клиент“ и политика срещу изпирането на пари за различните правни юрисдикции, към които сте свързани.",
        content142: "2. Знайте, че вашите клиенти и политиките за борба с прането на пари са както следва:",
        content143: "2.1 Обнародвайте политики за познаване на вашите клиенти и политики за борба с прането на пари и ги актуализирайте от време на време, за да отговарят на стандартите, определени от приложимите закони и разпоредби；",
        content144: "2.2 Обнародвайте и актуализирайте някои ръководни принципи и правила за работа с този уебсайт и нашите служители ще предоставят услуги в съответствие с ръководството на тези принципи и правила；",
        content145: "2.3 Проектиране и цялостни процедури за вътрешно наблюдение и контрол на транзакциите, като стриктна проверка на самоличността и организиране на формирането на професионален екип, отговорен за работата срещу изпирането на пари；",
        content146: "2.4 Възприемане на подход за предотвратяване на риска за извършване на надлежна проверка и текущ надзор на клиентите；",
        content147: "2.5 Преглеждайте и редовно проверявайте извършените транзакции；",
        content148: "2.6 Докладвайте съмнителни транзакции на компетентните органи；",
        content149: "2.7 Доказателство за самоличност, адрес и записи на транзакции ще се съхраняват най-малко шест години и могат да бъдат предоставени на регулаторните органи без допълнително известие до вас.",
        content150: "3. Информация за самоличност и проверка",
        content151: "3.1 Информация за самоличност",
        content152: "3.1.1 Съгласно различните регулации в различните юрисдикции и различните типове юридически лица, съдържанието на вашата информация, която събираме, може да е непоследователно, следната информация ще бъде събрана от регистрирани лица:",
        content153: "Основна лична информация: вашето име, адрес (и постоянен адрес, ако е различен), дата на раждане и националност и друга налична информация. Проверката на самоличността трябва да се основава на документи, издадени от официални или други подобни органи, като паспорти, лични карти или други документи за самоличност, изисквани и задействани от различни юрисдикции. Адресът, който предоставяте, ще бъде потвърден чрез подходящи методи, като например проверка на билета за пътнически транспорт или бележка за лихвен процент или проверка в избирателния регистър.",
        content154: "Валидна снимка: Преди да се регистрирате, трябва да предоставите снимка, на която държите личната си карта на гърдите си;",
        content155: "Данни за контакт: Телефон/мобилен номер и/или валиден имейл адрес.",
        content156: "3.1.2 Ако сте корпорация или друго юридическо лице, ние ще съберем следната информация, за да идентифицираме вас или крайния бенефициент на вашата доверителна сметка.",
        content157: "Удостоверение за регистрация и регистрация на дружеството; подробни удостоверителни материали за структурата на дружеството и описание на собствеността, доказващи решението на управителния съвет, което определя откриването и изпълнението на акаунта на този уебсайт; директори, които трябва да бъдат предоставени според изискванията, документи за самоличност на основния акционер и лицето, упълномощено да подписва акаунта на този уебсайт, ако е различен от пощенския адрес на дружеството, посочете пощенския адрес; Ако местният адрес на фирма не съответства на основния й бизнес адрес, тя се счита за клиент с по-висок риск и ще трябва да представи допълнителна допълнителна документация.",
        content158: "В зависимост от различните разпоредби в различните юрисдикции и различните видове юридически лица, ние изискваме други удостоверения и документи, издадени от властите, както и документи, които считаме за необходими.",
        content159: "3.1.3 Приемаме само английски или китайски версии на информация за самоличност. Ако не, моля, преведете вашата информация за самоличност на английски и я заверете нотариално.",
        content160: "3.2 Потвърдете Потвърдете",
        content161: "3.2.1 Изискваме да предоставите цялото съдържание на страницата на вашия документ за самоличност.",
        content162: "3.2.2 Молим ви да предоставите снимка, на която държите своя документ за самоличност на гърдите си.",
        content163: "3.2.3 Копията на оправдателните документи обикновено трябва да се сравняват с оригиналните ваучери. Въпреки това, копие е приемливо, ако подходящ и надежден сертификатор може да удостовери, че копието е точно и пълно възпроизвеждане на оригиналния документ. Такива сертификатори включват посланици, съдебни комисари, местни магистрати и др.",
        content164: "3.2.4 Изискването за идентифициране на крайния бенефициент и контрола върху акаунта е да се определи кои лица в крайна сметка притежават или контролират прекия клиент и/или да се установи, че текущи транзакции се изпълняват от името на други. Ако това е бизнес, трябва да се провери самоличността на основните акционери (като тези, които притежават 10% или повече от дяловете с право на глас). Като цяло, притежаването на 25% от акциите ще се счита за нормално рисково, а самоличността на акционера, който притежава 10% от акциите или има повече права на глас или акции, се счита за високорискова ситуация, и самоличността на акционера трябва да бъде потвърдена.",
        content165: "4. Наблюдавайте транзакциите",
        content166: "4.1 Ние задаваме и коригираме максималните лимити за дневни транзакции и теглене на валута от време на време въз основа на сигурността и действителните условия на транзакция;",
        content167: "4.2 Ако транзакциите се случват често при регистриран потребител или има необосновани обстоятелства, нашият професионален екип ще направи оценка и ще реши дали те са подозрителни;",
        content168: "4.3 Ако установим, че дадена транзакция е подозрителна въз основа на нашата собствена преценка, можем да предприемем ограничителни мерки като спиране на транзакцията, отхвърляне на транзакцията или дори да отменим транзакцията възможно най-скоро, ако е възможно, и да докладваме за това на компетентния орган, но няма да ви уведоми.;",
        content169: "4.4 Ние си запазваме правото да отхвърляме заявления за регистрация от лица от юрисдикции, които не отговарят на международните стандарти за борба с изпирането на пари, или лица, които могат да се считат за политически експонирани лица. Запазваме си правото да спрем или прекратим транзакции, които са подозрителни по наша преценка по всяко време, но ние не нарушаваме никое от вашите задължения или отговорности към вас.",
    },
    register: {
        formTitle1: "създавам",
        formTitle2: "Регистрирайте се с вашия имейл или номер на мобилен телефон",
        formTitle3: "Сметка",
        field1: "Код за потвърждение",
        field2: "Получете",
        field3: "потвърди парола",
        field4: "Код на поканата",
        field41: "(по избор)",
        field5: "Прочетох и съм съгласен",
        field6: "Условия за ползване",
        placeholder1: "моля, въведете код за потвърждение",
        content7: "моля, въведете код за потвърждение",
        content12: "Моля, въведете телефонен номер",
        content13: "Моля, въведете парола",
        content14: "моля, въведете вашия имейл",
        content18: "Моля, въведете паролата отново",
        content19: "Моля, съгласете се с условията на услугата",
        content20: "Моля, въведете правилен код за потвърждение",
        content23: "Все още не сте получили кода си за потвърждение?",
        content24: "Моля, въведете кода за потвърждение по-долу",
        registerSuccess: "регистрационен успех",
        content25: "Паролите са непоследователни",
        content26: "Моля, въведете правилния имейл адрес",
        content27: "Успешно нулиране на паролата"
    },
    download: {
        content1: "Търгувайте по всяко време и навсякъде",
        content2: "Перфектно съвместим с множество терминали, отговаряйки на нуждите от транзакции при различни сценарии по всяко време",
        content3: "Проверявайте пазарните условия в реално време по всяко време",
        content4: "Купувайте и продавайте лесно BTC, ETH, XRP и други цифрови активи",
        content5: "Получавайте ранни предупреждения за промени в цените за криптовалутите, които ви интересуват",
        content6: "Вижте биткойн спот заеми, фючърсни заеми и цени на опции",
        content7: "Сравнете цените на криптовалута на различни борси",
        title: "Изтегли",
        install: "Бележки за инсталиране",
        one: "1、Разрешаване на изтегляне на файлове с описание",
        two: "2、Файлът с описание е изтеглен",
        three: "3、Отидете на [Настройки] на телефона си и намерете [Общи]",
        four: "4、Профили и Диспечер на устройства",
        five: "5、Кликнете върху профила",
    },
    identity: {
        noAuthentication: {
            title: "Junior Certification",
            pleaseSelectYourCountry: "Моля, изберете вашата държава",
            name: "Име",
            enterName: "Моля въведете вашето име",
            city: "град",
            enterCity: "Моля, въведете вашия град",
            IDNumber: "Идентификационен номер",
            enterIDNumber: "Моля, въведете своя идентификационен номер",
        },
        noAdvancedAuthentication: {
            title: "Разширено сертифициране",
            infoCountry: "държавен регион",
            infoName: "Име",
            infoNumber: "Идентификационен номер",
            infoAddress: "地址",
        },
        text: "не е сертифициран",
        recertification: "ресертификация",
        certification: "Сертификация",
        authenticationInProgress: "проверени",
        inAuthentication: "Извършва се сертифициране",
        uploadTheFrontOfTheDocument: "Качете предната част на документа за самоличност",
        uploadTheReverseSideOfTheDocument: "Качете обратната страна на сертификата",
        uploadAPhotoOfAHandHeldID: "Качи снимка на личната си карта в ръка",
        pleaseUpload: "Моля те ",
        pleaseCompleteOrdinaryCertificationFirst: "Трябва да изчакате успеха на първичния преглед на сертифицирането",
        refused: "отхвърлени",
        reason: "причина",
        succeeded: "успели",
        uploading: "качване",
        newTitle: "Изберете държавата, в която е издадена вашата лична карта",
        pleaseOrdinaryCertificationFirst: "Моля, първо извършете първично сертифициране",
        text1: "Промяна на аватара",
        text2: "Псевдоним",
        text3: "сметка",
        text4: "Промяна на прякора",
        text5: "нов псевдоним",
        text6: "Въведете новия си псевдоним",
        text7: "Стара парола",
        text8: "Въведете старата си парола",
        text9: "нова парола",
        text10: "Въведете новата си парола",
        text11: "потвърди парола",

        text12: "Въведете новата си парола отново",
        text13: "нова пощенска кутия",
        text14: "Код за потвърждение",
        text15: "моля, въведете код за потвърждение",
        text16: "номера на вашия мобилен телефон",
        text17: "Нов номер на мобилен телефон",
        text18: "моля, въведете вашия телефонен номер",
        text19: "Код за потвърждение на мобилен телефон",
        text20: "Junior Certification",
        text21: "Моля, потвърдете информацията си за самоличност",
        text22: "Държава",
        text23: "град",
        text24: "Въведете вашия град",
        text25: "Въведете вашето име",
        text26: "Вашият идентификационен номер",
        text27: "Въведете своя идентификационен номер",
        text28: "лицева снимка на лична карта",
        text29: "Кликнете, за да качите вашите документи",
        text30: "повторно качване",
        text31: "качване",
        text32: "Снимка за лична карта",
        text33: "Щракнете, за да качите вашата снимка за лична карта",
        text34: "Свързахте Google Authenticator",
        text35: "ключ",
        text36: "Моля, въведете кода за потвърждение на Google",
        text37: "изпрати",
        text38: "Не може да бъде празно",
        text39: "Форматът на имейла е грешен",
        text40: "Две пароли са несъвместими",
        text41: "Копирано успешно",
        text42: "Неуспешно копиране",
        text43: "Модификация на аватара",
        text44: "промяна на паролата",
        text45: "Обвързване на имейл",
        text46: "Промяна на имейла",
        text47: "Подвързване на мобилен телефон",
        text48: "Модифициране на мобилен телефон",
        text49: "Google проверка",
        text50: "Свържете Google Authenticator",
        text51: "Въведете кода за потвърждение на Google",
        text52: "спаси",
        text53: "Потвърдете изпращането",
        text54: "Ревизирайте",
        text55: "подвързване",
        text56: "Изключете потвърждението от Google",
        text57: "Следваща стъпка",
        text58: "завършек",
        text59: "Потвърждението от Google е обвързано",
        text60: "Потвърждаването от Google е отделено",
        text61: "Предаден е първичен сертификат",
        text62: "Разширено сертифициране е изпратено",
        text63: "Няма качено изображение",
        text64: "Повторно изпращане",
        text65: "Моля, въведете псевдоним",
        text66: "Псевдонимът е запазен успешно",
        text67: "Все още няма качени изображения",
        text68: "Повторното задаване на паролата е завършено",
        text69: "Имейлът е променен успешно",
        text70: "Аватарът е запазен успешно",
        text71: "Качи изображение",
        text72: "вашата пощенска кутия",
        text73: "Въведете новия си имейл",
        text74: "Твоето име",
        text75: "Сертификация",
        text76: "Моля, проверете снимката за документ за самоличност"
    },
    retrievePassword: {
        formTitle1: "нулиране на парола",
        formTitle2: "За безопасността на вашите активи транзакциите са забранени в рамките на 24 часа след промяна на паролата.",
        formTitle3: "Възстанови парола",
        formTitle4: "Потвърдете промените",
        formTitle5: "Моля, въведете старата парола",
        formTitle6: "Моля, въведете нова парола"
    },
    home: {
        title1: "Най-популярната платформа за търговия с криптовалута",
        title3: "защо е ",
        title4: " Това е високопроизводителна блокчейн платформа с отворен код, предназначена да поддържа и управлява сигурна, съвместима и предвидима цифрова инфраструктура.",
        field1: "Установена борса",
        field2: "Финансови услуги за цифрови активи",
        field3: "Десетки милиони потребители",
        field4: "Създайте множество фондове за защита на инвеститорите",
        field5: "Бърза търговия",
        field6: "CME Gruop е в състояние да съпоставя поръчки с изключително ниска латентност за най-доброто търговско изживяване.",
        title5: "пазарна тенденция",
        title6: "виж повече",
        table1: "Валута",
        table2: "Последна цена",
        table3: "24 часа възходи и падения",
        table4: "24H обем на търговия",
        table5: "24H обем на транзакция",
        table6: "Цитати",
        title7: "относно ",
        title8: " Ние се ангажираме да предоставяме на потребителите най-модерните инструменти за търговия, иновативни технологии и несравнимо качествено обслужване на клиентите.",
        title9: "Сферата на цифровите активи се променя с всеки изминал ден Само ако бъдем далновидни и постигаме бърз напредък, можем да се справим с темпото на технологичните иновации.",
        title901: " Предоставяне на най-модерните услуги за търговия с цифрови активи на нашите потребители и глобални доставчици на ликвидност.",
        title10: "Ние твърдо вярваме, че всеки потребител заслужава най-доброто търговско изживяване.",
        title11: "Сигурност, на която можете да се доверите",
        title12: "Нашите усъвършенствани мерки за сигурност и средства SAFU защитават вашите цифрови активи от всички рискове.",
        title13: "Най-добри цени за транзакции",
        title14: "Преференциални тарифи за транзакции, конкурентни VIP права и се насладете на най-качествените услуги.",
        title15: "24*7 часа поддръжка за обслужване на клиенти",
        title16: "24/7 при всякакви метеорологични условия, режим на работа на пълен работен ден, ние ще отговорим на съответните ви запитвания възможно най-скоро.",
        title17: "Търговия с 0 такси",
        title18: "Използвайте множество методи на плащане, за да търгувате цифрови валути с нулеви такси за обработка, безопасно и бързо.",
        title19: "Търгувайте по всяко време и навсякъде",
        title20: "Перфектно съвместим с множество терминали, отговаряйки на нуждите от транзакции при различни сценарии по всяко време",
        title21: "Проверявайте пазарните условия в реално време по всяко време",
        title22: "Купувайте и продавайте лесно BTC, ETH, XRP и други цифрови активи",
        title23: "Получавайте ранни предупреждения за промени в цените за криптовалутите, които ви интересуват",
        title24: "Вижте биткойн спот заеми, фючърсни заеми и цени на опции",
        title25: "Сравнете цените на криптовалута на различни борси",
        title26: "Включи се сега",
        title27: "долар",
        title28: "Обем на търговия за 24 часа",
        title29: "Интегриран доставчик на ликвидност",
        title30: "потребител",
        title31: "Още",
        title32: "Binance Loan добавя CTSI & KSM като активи за обезпечение и пуска BUSD & USDT отстъпки за намаляване на лихвените проценти!",
        title33: "Нашето предимство",
        title34: "безопасно и стабилно",
        title35: "Топ технически екип, всеобхватна защита на сигурността, независимо проучване и разработване на високоскоростен двигател за синтез на транзакции, все още могат да работят стабилно и надеждно при масивни едновременни транзакции.",
        title36: "Професионално съответствие",
        title37: "Професионален оперативен екип, с дългогодишен опит в блокчейн и финанси, притежава съвместим лиценз за търговия с цифрови активи и има 100% гаранция за резерв.",
        title38: "Първо потребителят",
        title39: "С лице към глобалния пазар, поддръжка на множество езици, работа 24/7, силна поддръжка от общността и професионално обслужване на клиенти.",
        title40: "висока производителност",
        title41: "300 000 транзакции в секунда и време за отговор на поръчката под 1 милисекунда.",
        title42: "за нас",
        title43: "Търгувайте по всяко време и навсякъде",
        title44: "Перфектно съвместим с множество терминали, отговаряйки на нуждите от транзакции при различни сценарии по всяко време",
        title45: "(Сканирайте QR кода за изтегляне)",
        title46: "Новини за цифровите валути",
        title47: "наш бизнес партньор",
        title48: "Списък на губещите",
        title49: "24ч оборот",
        title50: "24 часа увеличение и намаляване"
    },
    quotation: {
        marketTrading: "Цитати",
        turnover: "Сила на звука",
        optional: "Не е задължително",
        contractMarket: "договорен пазар",
        currencyPair: "валутна двойка",
        latestPrice: "Цена на затваряне",
        upsAndDowns: "Промяна на цитата",
        highest: "Най-високо",
        lowest: "най-нисък",
        transactionAmount: "Обем на транзакцията",
        operate: "оперират",
        buy: "търговия",
        topTurnovers: "Списък с транзакции",
        topGainers: "Списък на печелившите",
        tradingPair: "търговска двойка",
        buyOrder: "Купува",
        sellOrder: "поръчка за продажба"
    },
    accountChange: {
        demo: "симулация",
        realAccount: "действителна сметка",
        demoAccount: "Демо сметка",
        accountRole: "Роля на акаунта",
        pleaseSelect: "Моля избери",
        AccountChangeType: "Тип промяна на акаунта",
        AccountType: "Тип на профила",
        currencyType: "Тип валута",
        allType: "Всички видове",
        allAccount: "Всички акаунти",
        allCoin: "Всички валути",
        coin: "Валута",
        amount: "Промяна на сумата",
        balance: "Салдо по сметка",
        time: "време",
        title: "Записи за промени в акаунта",
        filtrar: "филтър",
        check: "преминат към",
        showOnly: "Показвайте само наличности във валута",
        holdAssets: "Валутен баланс",
        accountList: "Списък с акаунти"
    },
    contractTransaction: {
        chart: "графика",
        basicEdition: "Основна версия",
        depthMap: "Карта на дълбочината",
        second: "Второ",
        minute: "точка",
        day: "небе",
        week: "седмица",
        month: "луна",
        open: "отворен",
        trade: "търговия",
        buyLong: "дълга покупка",
        buyShort: "къса покупка",
        cannotBuy: "Тази валута не поддържа транзакции с договор за доставка",
        cannotBuy1: "Тази валута не поддържа постоянна търговия",
        tradingAssets: "търговски активи",
        amountAvailable: "Налично количество",
        timeStr: "време",
        transactionPeriod: "период на търговия",
        quantity: "количество",
        enterQuantity: "Моля, въведете количество",
        buyIn: "Отидете дълго",
        latestTransaction: "най-нова транзакция",
        time: "време",
        direction: "посока",
        price: "цена",
        sell: "къс",
        positionOrder: "Поръчка за доставка",
        historicalOrders: "Исторически порядки",
        product: "продукт",
        realAccount: "(реална сметка)",
        demoAccount: "(Демо сметка)",
        openingTime: "време за поръчка",
        openingPrice: "Начална цена",
        curretPrice: "Текуща цена",
        liquidationPrice: "Цена на затваряне",
        profitOrLoss: "Печалба и загуба",
        endTime: "Края на работното време",
        areYouSureToBuy: "Сигурни ли сте, че купувате?",
        areYouSureToLongBuy: "Сигурни ли сте, че искате да продължите дълго?",
        areYouSureToShortBuy: "Сигурни ли сте, че искате да купите кратко?",
        successfullyBought: "Купете успешно",
        minBuy: "Минимален бай-ин",
        assets: "активи",
        withdraw: "оттегляне",
        entrustedOrder: "Поръчка",
        total: "обща сума",
        continueToPlaceOrder: "Продължете да правите поръчка",
        orderConfirmation: "Потвърждение на поръчката",
        buyRu: "Купува",
        sellChu: "продавам",
        areYouSureToSell: "Сигурни ли сте, че ще продадете?",
        operation: "оперират",
        buyCover: "позиция на капака",
        commitSuccess: "Транзакцията е успешна",
        onlyEnterIntegers: "Могат да се въвеждат само цели числа",
        trend: "Тенденция",
        lotteryTime: "Срок за поръчка",
        countdown: "обратно броене",
        period: "Проблем",
        cycle: "Времеви период",
        unlimited: "Неограничен",
        put: "Put",
        call: "Call",
        pending: "По поръчка",
        unopened: "Все още не е нарисувано",
        opened: "Наградата е изтеглена",
        settlementPrice: "Цена за уреждане",
        rateOfReturn: "сетълмент цена доходност",
        currentPositions: "Текущата позиция",
        positionQuantity: "Количество на позицията",
        guarantee: "марж",
        text1: "CALL",
        text2: "PUT",
        text3: "Чака да купи",
        text4: "Поръчано количество",
        text5: "Броят на транзакциите",
        text6: "Отказ",
        text7: "време за доставка",
        text8: "Напомняне за анулиране",
        text9: "Сигурни ли сте, че искате да анулирате поръчката?",
        text10: "Незаконно количество",
        text11: "Напомняне за поръчка",
        text12: "Сигурни ли сте, че купувате нагоре?",
        text13: "Сигурни ли сте, че купувате пут?",
        text14: "Анулирането е успешно"
    },
    mining: {
        title1: "Водещата в света блокчейн платформа за копаене на цифрови активи",
        title2: "Отворен и прозрачен · безопасен и стабилен",
        title3: "Моля, изберете валута",
        title4: "Добив на годишна база",
        title5: "небе",
        title6: "Период на добив",
        title7: "информация за продукта",
        btn: "Моят сега",
        btn2: "закриване",
        tabs1: "в ход",
        tabs2: "изкупен",
        table1: "Име на продукта",
        table2: "Период на добив",
        table3: "Време за добив",
        table4: "Сума за копаене",
        table5: "Краен срок",
        table6: "Пристъпва към зрялост",
        table7: "Статус на поръчката",
        egularMining: "Добив редовно",
        inProgress: "в ход",
        redeemed: "изкупен",
        redemption: "изкупление",
        regularMining: "Добив редовно",
        earlyRedemption: "предсрочно изкупуване",
        need: "трябва",
        handlingFee: "такса за обработка",
        redemptionConfirmationMessage: "Моля, потвърдете дали да осребрите предварително？",
        form1: "Добив на годишна база",
        form2: "Период на добив",
        form3: "Майнинг валута",
        form4: "Сума на абонамента (минимум/максимум)",
        form5: "Такса за предсрочно изкупуване: ",
        form6: "изкупна цена",
        form7: "Налични средства",
        form8: "изкупна цена",
        form9: "Налични средства",
        form10: "Моля, въведете сумата на покупката",
        form11: "всичко",
        form12: "Очаквани приходи",
        form13: "Недостатъчно налични средства",
        form14: "Моля, въведете сумата на покупката",
        form15: "Моята поръчка",
        form16: "доходи",
        form17: "подробности за поръчката",
        form18: "Инструкции за предсрочно изкупуване:",
        form19: "Сума на абонамента (минимум)",
        form20: "Сума на абонамента (максимум)",
        form21: "Задържано количество",
        form22: "Купуване на време",
        form23: "време за обратно изкупуване",
        form24: "над",
        form25: "Абонаментът е успешен",
        form26: "Осребряването е успешно",
        form27: "Лесно финансово управление с над 25% възвръщаемост, превъзхождащо пазара и можете също да получавате награди след покупка",
        form28: "Поканете приятели, за да получите награда от 50 USDT, а договорните ваучери също могат да върнат 20% комисионна."
    },
    assets: {
        content1: "Активи на сметката",
        content2: "Днешните печалби",
        content3: "текуща сметка",
        content4: "Действителната сметка е вашите действителни активи в сметката, които могат да се използват за транзакции и тегления.",
        content5: "Теглене на монети",
        content6: "Депозирайте монети",
        content7: "обмен",
        content8: "трансфер",
        content9: "Моля избери",
        content10: "Демо сметка",
        content11: "действителна сметка",
        content12: "придобиват активи",
        content13: "Сигурни ли сте, че искате да преминете към реален акаунт?",
        content14: "Сигурни ли сте, че искате да преминете към демо акаунт?",
        content15: "постигни успех",
        table1: "Валута",
        table2: "количество",
        table3: "замразяване",
        table4: "Наличен",
        dialog1: "информация за продукта",
        dialog2: "1、Този актив е разрешено да се използва само в режим на демо сметка",
        dialog3: "2、За да се предотврати злоупотреба, е разрешено само едно обратно изкупуване в рамките на един месец.",
        dialog4: "3、Получаването на активи ще добави сумата на получените активи на първоначалната база и няма да промени състоянието на позицията.",
        dialog5: "4、Ако имате други въпроси, моля, свържете се с отдела за обслужване на клиенти",
        dialog6: "закриване",
        dialog7: "Вземете демонстрационни активи сега",
        dialog8: "трансфер в",
        dialog9: "трансфер навън",
        dialog10: "превключвател",
        dialog11: "Остойностяване",
        dialog12: "Демо активи",
        dialog13: "моята сметка",
        dialog14: "Общи активи по сметката",
        dialog15: "Преглед на активите",
        dialog16: "Обща оценка на активите",
        dialog17: "Оценка на активите",
        dialog18: "Днешните печалби",
        dialog19: "замразяване на средства",
        dialog20: "Можете да получавате симулирана квота за активи всеки месец",
        dialog21: "получавам",
        dialog22: "Получихте успешно",
        dialog23: '30 дни кумулативен доход',
        dialog24: "Финансов продукт",
        dialog25: "Моето финансово управление",
        dialog26: "Исторически финансов мениджмънт",
        dialog27: "исторически запис",
        dialog28: "Записи за финансиране"
    },
    validator: {
        dialog14: "валидатор",
        dialog15: "Валидатор за свързване",
        dialog16: "ключ за валидатор",
        dialog17: "Код за потвърждение",
        dialog18: "Валидатор QR код",
        dialog19: "ключ за валидатор",
        dialog20: "спаси",
        dialog21: "Моля, изберете валидатор",
        dialog22: "ключ за копиране",
        dialog23: "Запазено успешно",
        dialog24: "моля, въведете код за потвърждение",
        dialog25: "Приятелско напомняне: Преди да потвърдите запазването, моля, отворете съответното ПРИЛОЖЕНИЕ и сканирайте QR кода по-долу или добавете ключа ръчно!",
        dialog26: "Активирайте вашия удостоверител, за да осигурите максимална сигурност за вашия акаунт",
        dialog27: "Ще трябва да въведете уникален код за потвърждение, достъпен през вашия мобилен телефон всеки път, когато влизате или теглите средства.",
        dialog28: "Настройте валидатор",
        dialog29: "помогне",
        dialog30: "Не сте обвързали кода за удостоверяване. Получете по-силна защита с удостоверител.",
        dialog31: "Валидаторът все още не е настроен, моля, настройте го първо",
        dialog32: "Отидете на настройките"
    },
    recharge: {
        title1: "Не сте сигурни как да купувате с цифрова валута?",
        title2: "Само три лесни стъпки!",
        title3: "Изберете цифровата валута, която искате да закупите, от падащото меню и въведете количеството или сумата за покупка.",
        title4: "Изберете предпочитания от вас начин на плащане",
        title5: "След като плащането бъде потвърдено, цифровата валута, която сте закупили, ще бъде автоматично прехвърлена към вашия акаунт.",
        title6: "изберете валутата, която искате да депозирате",
        title7: "Депозитен запис",
        table1: "Валута",
        table2: "количество",
        table3: "Име на веригата",
        table4: "състояние",
        table5: "причина",
        table6: "време",
        table7: "Вижте ваучера",
        dialog1: "Моля, въведете кода за потвърждение по-долу",
        dialog2: "код за плащане",
        dialog3: "копие",
        dialog4: "адрес",
        dialog5: "Депозитна сметка",
        dialog6: "Екранна снимка на транзакция",
        dialog7: "важно съобщение",
        dialog8: "Моля, попълнете сумата на депозита",
        dialog9: "качи изображение",
        dialog10: "Моля, въведете съдържание",
        dialog11: "Моля, качете екранни снимки на презареждане",
        dialog12: "Не е прегледан",
        dialog13: "отхвърлени",
        dialog14: "Депозиран",
        tip1: "Изпратено успешно",
        tip2: "Копирано успешно",
        tip3: "Неуспешно копиране",
        tip4: "Моля, изберете валутата, която искате да презаредите",
        tip5: "1.Посоченият по-горе адрес за депозит е официалният адрес за плащане на платформата. Всяка загуба на средства, причинена от погрешен депозит, ще бъде поета от вас.；",
        tip6: "2.Моля, уверете се, че вашият компютър и браузър са защитени, за да предотвратите подправяне или изтичане на информация.；",
        tip7: "3.След като презаредите горния адрес, целият мрежов възел трябва да потвърди, преди сметката да може да бъде кредитирана;",
        tip8: "4.Моля, изберете горната токен система и валута и прехвърлете съответната сума за депозит. Моля, не прехвърляйте никакви други несвързани активи, в противен случай тя няма да бъде извлечена.",
        tip9: "Запазете QR кода",
        tip10: "допълнете",
        tip11: "важно съобщение",
        tip12: "Извънсайтови връзки",
        tip13: "Презаредете QR код",
        tip14: "Следваща стъпка",
        tip15: "Запис за презареждане",
        tip16: "Подробности за презареждане",
        tip17: "Адрес за депозит",
        tip18: "Бързо плащане",
        tip20: "Недостатъчен баланс",
        tip22: "Изпратено, чака се потвърждение",
        tip23: "чака плащане",
        tip24: "Количество",
        tip25: "Плащането е изпратено, чака се потвърждение за блокиране",
        tip26: "Плащането е отхвърлено",
        tip27: "Неуспешно плащане",
        tip28: "Успешно плащане",
        bankChannel: "Канал за банкова карта",
        tip29: "Исторически търсения",
        tip30: "Валутен списък",
        tip31: "Изберете мрежа",
        tip32: "Когато презареждате тази валута, моля, презареждайте само през поддържаните мрежи по-долу. Ако презареждате през други мрежи, средствата ще бъдат загубени.",
        tip33: "Когато теглите тази валута, теглете само през поддържаните мрежи по-долу. Ако теглите през други мрежи, средствата ще бъдат загубени.",
        tip34: "Бързо презареждане",
        tip35: "Сканирайте кода за презареждане",
        tip36: "Ръчно презареждане",
        tip37: "Network",

        tip38: "Адрес за презареждане",
        tip39: "Сума за презареждане",
        tip40: "Качване на разписка за транзакция",
        tip41: "качи изображение",
        tip42: "потвърди подаването",
        tip43: "потвърди плащането",
        tip44: "Забележка: Моля, потвърдете адреса, който трябва да презаредите. Ние не носим отговорност за загуба на пари, ако го попълните неправилно.",
        tip45: "напомням",
        tip46: "Адресът е копиран успешно!",
        tip47: "Копирането на адреса не бе успешно!",
        tip48: "Недостатъчен наличен баланс",
        tip49: "Презареждането беше изпратено успешно и чака потвърждение във веригата.",
        tip50: "Неуспешно презареждане",
        tip51: "Сумата за презареждане е грешна",
        tip52: "Свързването е неуспешно",
        tip53: "Портфейлът не е влязъл",
        tip54: "връзката е отказана",
        tip55: "Изпратено успешно, чака преглед и одобрение от отдела за обслужване на клиенти",
        tip56: "Моля, качете екранна снимка на разписката за транзакцията",
        tip57: "Неуспешно изпращане",
        tip58: "Запис за презареждане",
        tip59: "Запис на тегления",
        tip60: "Валута за презареждане",
        tip61: "Валута за теглене",
        tip62: "Адрес за презареждане",
        tip63: "Екранната снимка показва",
        tip64: "Кликнете, за да увеличите изображението",
        tip65: "Време за презареждане",
        tip66: "Причина за отказ",
        tip67: "Сума за теглене",
        tip68: "Получена сума",
        tip69: "Мрежа за теглене на пари в брой",
        tip70: "Адрес за теглене",
        tip71: "Време за теглене",
        tip72: "закриване",
        tip73: "Екранна снимка на транзакция",
        tip74: "Предстои преглед",
        tip75: "отхвърлени",
        tip76: "завършен",
        tip77: "отхвърлени",
        tip78: "Одитиран",
        tip79: "Изплатени",
        tip80: "екстракт",
        tip81: "трансферна мрежа",
        tip82: "Адрес/Фактура",
        tip83: "Изтеглете всички",
        tip84: "Моля, не теглете пари директно на адреса за групово финансиране или ICO, в противен случай няма да можете да получите токените, издадени от груповото финансиране или ICO.",
        tip85: "Пристигащо количество",
        tip86: "Потвърдете тегленето",
        tip87: "Грешен адрес за теглене",
        tip88: "Грешна сума за теглене",
        tip89: "Сумата за теглене е поне",
        tip90: "Максималната сума за теглене е",
        tip91: "Искането за теглене е подадено",
        tip92: "списък с адреси",
        tip93: "Все още не сте добавили адрес",
        tip94: "Добавете го сега",
        tip95: "Добавете адрес",
        tip96: "добавете нов адрес",
        tip97: "Моля избери",
        tip98: "адрес",
        tip99: "Моля, изберете мрежа за трансфер",
        tip100: "Моля, въведете адрес",
        tip101: "Адресът е добавен успешно",
        tip102: "в транзакция",
    },
    fundExchange: {
        title1: "Как да обменяте средства?",
        title2: "Изберете подходящата валута, която да конвертирате.",
        title3: "Изберете подходящата валута за конвертиране.",
        title4: "Въведете сумата за обмен и щракнете върху Изпрати, за да завършите обмена на средства.",
        title5: "от",
        title6: "пристигат",
        title7: "Обменно количество",
        title8: "валутен курс",
        title9: "На разположение",
        title10: "Моля, въведете количеството за обратно изкупуване",
        title11: "Няма съответстваща търговска двойка за обмен.",
        title12: "Моля, въведете количеството за изкупуване",
        title13: "Осребряването е успешно",
        title14: "Борсов запис",
        table1: "Използвайте валута",
        table2: "количество",
        table3: "валутен курс",
        table4: "Обмяна на валута",
        table5: "Касова бележка",
        table6: "време",
        title15: "от",
        title16: "В момента няма налични активи, моля, изберете друг"
    },
    fundTransfer: {
        title1: "Как да прехвърлите средства?",
        title2: "Изберете текущия акаунт, който трябва да бъде прехвърлен.",
        title3: "Изберете акаунта, който искате да прехвърлите.",
        title4: "Въведете сумата на превода и щракнете върху Изпрати, за да завършите превода.",
        title5: "Валута",
        title6: "Трансферно количество",
        title7: "Моля, въведете сумата за превод",
        title8: "трансферен запис",
        title9: "Моля, изберете тип портфейл",
        title10: "Моля, изберете валута",
        title11: "Моля, изберете тип портфейл",
        title12: "Моля, изберете валута",
        title13: "Моля, въведете сумата за превод",
        title14: "Изпратено успешно",
        table1: "Прехвърляне на сметка",
        table2: "трансферна валута",
        table3: "Трансферно количество",
        table4: "трансферна сметка",
        table5: "време",
        table6: "трансфер",
        table7: "Прехвърляне на средства",
        table8: "Трансфер до",
        table9: "трансферен запис",
        table10: "Подробности за прехвърляне",
        table11: "Прехвърлянето успешно",
        table12: "Прехвърлянето е неуспешно",
        table13: "Текущата сметка не може да бъде прехвърлена"
    },
    withdrawal: {
        title1: "важно съобщение",
        title2: "1.За да предотвратите арбитраж, можете да кандидатствате за теглене на валута, когато обемът на транзакцията достигне квотата.",
        title3: "2.Заявлението за теглене ще бъде кредитирано в рамките на 24 часа след подаване. Ако тегленето не бъде получено след очакваното време за теглене, моля, свържете се с онлайн обслужването на клиенти.",
        title4: "3.След подаване на заявлението за теглене средствата са в замразено състояние, тъй като тегленето е в ход и средствата са временно задържани от системата. Това не означава, че сте загубили актива или че има нередност с актива.",
        title5: "Валута",
        title6: "адрес на портфейла",
        title7: "Количество изтеглени монети",
        title8: "Рекорд за теглене на монети",
        title9: "Моля, изберете валута",
        title10: "Моля, изберете тип верига",
        title101: "",
        title11: "Моля, въведете",
        title12: "адрес на портфейла",
        title13: "Изпратено успешно",
        title14: "в процес на преразглеждане",
        title15: "Прегледът е успешен",
        title16: "Неуспешен одит",
        title17: "Изплатени",
        title18: "Моля, въведете или поставете адреса на вашия портфейл",
        title19: "Моля, въведете сумата за теглене",
        title20: "fee",
        title21: "Действително пристигане",
        table1: "Валута",
        table2: "Количество изтеглени монети",
        table3: "Име на веригата",
        table4: "адрес на портфейла",
        table5: "състояние",
        table6: "причина",
        table7: "време на прилагане",
        table8: "Теглене на монети",
        table81: "Теглене на монети",
        table9: "Адрес за теглене",
        table10: "Моля, изберете валутата, която искате да изтеглите",
        table11: "Моля, уверете се, че сте въвели",
        table12: 'Адрес (обикновено започва с "0x")',
        table13: "Монети, които могат да бъдат изтеглени (приспадат се таксите за обработка):",
        table14: "Изберете валута",
        table15: "Срещате проблеми? Незабавна обратна връзка",
        table16: "баланс",
        table17: "Подробности за теглене",
        password: "парола",
        passwordTips: "Моля, въведете парола",
        passwordAg: "потвърди парола",
        passwordAgTips: "Моля, въведете паролата отново",
        oldPassword: "Стара парола",
        oldPasswordTips: "Моля, въведете старата парола",
        newPassword: "нова парола",
        newPasswordTips: "Моля, въведете нова парола",
        passwordNotSame: "Паролите са непоследователни",
        withdrawPasswordSet: "Задайте парола за теглене",
        withdrawPasswordModify: "Променете паролата за теглене",
        withdrawPassword: "Оттеглете паролата",
        withdrawPasswordTips: "Моля, въведете паролата за теглене",
        setWithdrawPasswordFirst: "Моля, първо задайте парола за теглене",
        withdrawPasswordSetSuccess: "Настройката е успешна",
        withdrawPasswordModifySuccess: "Успешно модифициран",
        submit: "Изпращане",
    },
    customer: {
        content1: "онлайн услуга",
        content2: "обслужване на клиенти",
        content3: "Моля, въведете вашата информация за контакт",
        content4: "Моля, въведете съдържание",
        content5: "изпрати",
        content6: "Неуспешно изпращане, неуспешна мрежова връзка",
        content7: "снимка",
        content8: "съобщението е празно",
        content9: "моя дял",
        content10: "сподели връзка",
        content11: "запази Картина",
        content12: "моите приходи",
        content13: "Описание на нивото",
        content14: "Големина на отбора",
        content15: "Приходи от покана",
        content16: "Описание на правилото",
        content17: "ниво на членство",
        content18: "Сумата за презареждане е по-голяма от",
        content19: "Отборно ниво",
        content20: "Екипно ниво и приходи",
        content21: "Да отговаря на условията",
        content22: "Приходи от разпределение",
        content23: "екип на ниво",
        content24: "ниво, покана",
        content25: "валидни членове",
        content26: "първичен доход",
        content27: "вторичен доход",
        content28: "Доход от ниво 3",
    },
    standardContract: {
        increaseMargin: "увеличаване на маржа",
        increaseAmount: "увеличаване на сумата",
        Pleaseenterthemargin: "Моля, въведете размера на маржа, който да бъде увеличен",
        Pleaseenterthecorrect: "Моля, въведете правилната сума на депозита",
        Increasemarginsuccessfully: "Увеличете маржа успешно",
        takeProfitPriceWrong: "Цената на тейк печалба е грешна",
        stoppriceerror: "Грешка в стоп цената",
        thetakeprofit1: "Цената на тейк печалбата трябва да бъде по-висока от пазарната цена",
        thetakeprofit2: "Цената на стоп загубата трябва да е по-ниска от пазарната цена",
        thetakeprofit3: "Цената на тейк печалбата трябва да е по-ниска от пазарната цена",
        thetakeprofit4: "Цената на стоп загубата трябва да е по-висока от пазарната цена",
        thetakeprofit5: "Грешно количество",
        estimatedprofitloss: "Очаквана печалба и загуба",
        positionAmount: "Брой позиции",
        closeAmount: "Крайно количество",
        whenthelatest: "При достигане на последната цена",
        whenthelatest2: "Поръчката за тейк печалба на пазарната цена ще бъде задействана за затваряне на текущата позиция. Очаквана печалба и загуба",
        whenthelatest3: "Пазарната поръчка за стоп загуба ще бъде задействана, за да затвори текущата позиция. Очаквана печалба и загуба",
        contract: "договор",
        ordercanceledsuccessfully: "Поръчката е анулирана успешно",
        successfullyordered: "успешно поръчан",
        positionopeningreminder: "Напомняне за отваряне на позиция",
        wrongquantity: "Грешно количество",
        quantitycannot: "Количеството не може да бъде по-голямо от",
        modificationstoploss: "Успешна промяна на стоп печалба и стоп загуба",
        positionclosedsuccessfully: "Позицията е затворена успешно",
        orderCancellation: "Анулиране на поръчка",
        orderCancellation2: "Сигурни ли сте, че искате да анулирате поръчката?",
        tobeexecuted: "Да се ​​изпълни",
        expired: "просрочен",
        failed: "се провали",
        contractTransaction: "Безсрочен договор",
        increase: "Нараства",
        openPosition: "Пълен склад",
        isolatedPosition: "Изолирана позиция",
        limitOrder: "ценова граница",
        marketOrder: "пазарна цена",
        pleaseSelectLeverage: "Моля, изберете ливъридж",
        pleaseEnterQuantity: "Моля, въведете количество",
        canOpenMore: "Максимална позиция, която може да се отвори",
        contractAmount: "Сума на договора",
        openingFee: "такса за обработка",
        currentPosition: "Позиция",
        historicalPositions: "Исторически транзакции",
        currentCommission: "Текуща поръчка",
        historicalCommission: "историческа комисия",
        buyPrice: "изкупна цена",
        income: "печалба",
        quantity: "количество",
        marginRate: "маржин процент",
        initialMargin: "Първоначален марж",
        estimatedPriceParity: "Цена принудителна ликвидация",
        operate: "оперират",
        finishQuantity: "Обем на транзакцията",
        averagePrice: "средна цена на сделката",
        pleaseEnterLeverage: "Моля, въведете ливъридж",
        takeProfitAndStopLoss: "TP/SL",
        takeProfit: "TP",
        stopLoss: "SL",
        openLong: "Long",
        openShort: "Short",
        liquidation: "Близка позиция",
        marketLquidation: "Пазарната цена е равна",
        cancel: "Отмени поръчката",
        enterBuyPrice: "Моля, въведете покупната цена",
        areYouSureLquidation: "Сигурни ли сте, че ще затворите позицията?",
        confirm: "Сигурен",
        enterStopWinPrice: "Моля, въведете цената на печалбата",
        enterStopLossPrice: "Моля, въведете цена за стоп загуба",
        commissionTime: "Комисионно време",
        commissionPrice: "Комисионна цена",
        commissionQuantity: "Общ размер на комисионните",
        volumeAlreadyTraded: "Попълнена сума",
        areYouSureToWinOrLoss: "Сигурни ли сте, че искате да спрете печалбата и да спрете загубата?",
        maxQuantity: "Максимална позиция",
        saleQuantity: "Позицията е затворена",
        salePrice: "средна цена на затваряне",
        saleTime: "време",
        succeeded: "успели",
        cancelled: "Отменен",
        piece: "отворен",
        triggerPrice: "задействаща цена",
        setWin: "Задайте тейк печалба",
        setLoss: "Задайте стоп загуба",
        enterWinQuantity: "Моля, въведете сумата за тейк печалба",
        enterLossQuantity: "Моля, въведете сумата на стоп загубата",
        planCommission: "Планова комисионна",
        enterWinTriggerPrice: "Моля, въведете цената за задействане на печалбата",
        enterLossTriggerPrice: "Моля, въведете цената на спиране на загубата",
        insufficientQuantity: "Недостатъчно количество",
        enterTriggerPrice: "Моля, въведете начална цена",
        tips1: "Цената на вашата поръчка е по-висока от текущата цена и тя ще бъде изпълнена директно на текущата пазарна цена. Сигурни ли сте, че искате да купите?",
        tips2: "Цената на вашата поръчка е по-ниска от текущата цена и тя ще бъде изпълнена директно на текущата пазарна цена. Сигурни ли сте, че купувате?",
        type: "Тип",
        increaseQuantity: "Увеличете позицията",
        reduceQuantity: "Намалете позициите",
        limitCommission: "лимитирана поръчка",
        tips3: "Цената на стоп загубата трябва да е по-ниска от пазарната цена",
        tips4: "Цената на тейк печалбата трябва да бъде по-висока от пазарната цена",
        tips5: "Цената на стоп загубата трябва да е по-висока от пазарната цена",
        tips6: "Цената на тейк печалбата трябва да е по-ниска от пазарната цена",
        tips7: "Цената на стоп загубата трябва да бъде по-ниска от пазарната цена и по-ниска от цената на поръчката",
        tips8: "Цената на печалбата трябва да бъде по-висока от цената на поръчката (може да бъде по-малка от пазарната цена)",
        tips9: "Цената на стоп загубата трябва да бъде по-висока от пазарната цена и по-висока от цената на поръчката",
        tips10: "Цената на печалбата трябва да е по-малка от цената на поръчката (може да бъде по-голяма от пазарната цена)",
        accountEquity: "Салдо по сметка",
        unrealizedPL: "нереализирана печалба или загуба",
        tips11: "Сигурен ли си, че си прав",
        tips12: "Пазарна цена",
        tips13: "Затворете всички позиции",
        tips14: "Не напомняйте отново",
        profitRate: "Приключваща норма на възвръщаемост",
        openTime: "Време на отваряне",
        unwindTime: "Края на работното време",
        dealTime: "Време за транзакция",
        amountClose: "Сума на затворена позиция",
        long: "Long",
        short: 'Short',
        orderQuantity: "Поръчано количество",
        entrustedMargin: "поверен марж",
    },
    spotGoods: {
        spotGoods: "Флаш обмен",
        sellPrice: "продажна цена",
        orderRecord: "Запис за флаш изкупуване",
        transactionTime: "Време за транзакция",
        maxBuy: "налични за покупка",
        maxSell: "Предлага се за продажба",
        purchaseQuantity: "Количество за покупка",
        slippage: "Приплъзване",
        convertTips: "Ние ще затворим сделката на най-изгодната цена с приплъзване от 0-5%.",
        changePrice: "Текуща борсова цена",
        consume: "консумират",
        consumeAmount: "количество",
        get: "получавам",
        changeTips: "Сигурни ли сте, че искате да осребрите?",
        confirm: "Потвърдете размяната",
        getAmount:"количество"
    },
    news: {
        title: "Център за новини",
        redMore: "Прочетете още",
    },
    credit: {
        credit: "кредитен рейтинг",
        creditScore: "общ кредитен рейтинг",
        latestEntry: "последен запис",
        liveUpdate: "Актуализация на живо",
        systemEvaluation: "Оценка на системата",
        time: "дата",
        name: "име",
        reason: "причина",
        scoreStory: "Запис на кредитен рейтинг"
    },
    borrowing: {
        borrowing: "заем",
        diversifiedMarket: "Диверсифицирани пазари",
        totalSupply: "Общо предлагане",
        totalBorrowings: "общо взети заеми",
        tips1: "Това е общата сума, която можете да заемете срещу вашето обезпечение, до лимита за заемане.",
        tips2: "Вашият стабилен лихвен процент ще остане същият за целия срок на кредита. Препоръчва се за дългосрочни доставки и потребители, които обичат предвидимостта.",
        totalSupplys: "общо предлагане",
        supplyAPR: "скорост на предлагане",
        totalBorrowings: "Тотално заемане",
        borrowAPR: "процент на заеми",
        check: "Проверете",
        market: "пазар",
        availableLiquidity: "Налична ликвидност",
        currencyPrice: "текуща валутна цена",
        supplyAssets: "доставка на активи",
        tips3: "Забележка: Лихвеният процент по-долу е фиксиран лихвен процент след изтичане на периода на предлагане, главницата плюс приходите ще бъдат върнати във вашата сметка.",
        supplyCycle: "цикъл на доставка",
        minimumSupply: "минимално предлагане",
        supply: "доставка",
        borrowedAssets: "заети активи",
        tips4: "Важно е да знаете: За да вземете пари назаем, ще трябва да предоставите всички обезпечени активи или доказателства,",
        tips5: "Моля, вижте описанието на ипотечния актив.",
        repaymentCycle: "погасителен цикъл",
        BorrowableAmount: "Налична сума на заема",
        borrow: "заем",
        accountInformation: "Информация за профила",
        walletBalance: "баланс на портфейла",
        canSupply: "На разположение",
        AmountCanBeBorrowed: "Общата налична сума на заема",
        borrowedAmount: "Заета сума",
        remainingAmount: "оставащ баланс",
        getBorrowednAmount: "Вземете кредитен лимит",
        supplyOrder: "поръчка за доставка",
        borrowedOrder: "поръчка за заем",
        supplyAmount: "количество доставка",
        expectedProfits: "Очаквано завръщане",
        supplyTime: "Време за доставка",
        expirationTime: "Краен срок",
        borrowingAmount: "Заета сума",
        dueRepayment: "Сума за погасяване",
        borrowingTime: "Време за освобождаване",
        repaymentTime: "Време за погасяване",
        repay: "погасяване",
        supplyCurrency: "доставка на валута",
        buyNow: "Купи сега",
        supplyRecords: "записи за доставка",
        borrowRecords: "Записи за заеми",
        completed: "завършен",
        borrowNow: "Заемете сега",
        borrowCurrency: "Заемане на валута",
        borrowMin: "най-малък",
        borrowMax: "максимум",
        borrowRange: "Сума на заема (минимум/максимум)",
        tips6: "Моля, погасете навреме, ако е просрочена, ще бъде начислена допълнителна дневна сума от (главница + лихва).",
        tips7: "Просрочена такса.",
        pleaseEnterBorrowAmount: "Моля, въведете сумата на кредита",
        interest: "интерес",
        tips8: "Сигурни ли сте, че искате да погасите предварително?",
        borrowChannel: "Канал за заемане",
        tips9: "Нека започнем, като ви опознаем",
        name: "име",
        lastName: "фамилия",
        birthDate: "дата на раждане",
        tips10: "Малко повече информация, какъв е вашият адрес?",
        familyAddress: "Домашен адрес (включително номер на блок)",
        city: "град",
        country: "нация",
        postalCode: "пощенски код",
        pleaseEnterYourHomeAddress: "Моля, въведете домашния си адрес",
        tips11: "Разкажете ни за финансовото си състояние",
        tips12: "Може да се наложи да потвърдим тази информация по-късно, така че, моля, опитайте се да бъдете възможно най-точни",
        yourMonthlyIncome: "вашият месечен доход",
        enterYourMonthlyIncome: "Моля, въведете вашия месечен доход",
        extraIncomeOptional: "Допълнителен доход (по избор)",
        enterExtraIncome: "Моля, въведете вашия допълнителен доход",
        monthlyRentOrMortgagePayment: "Плащане на месечен наем или ипотека",
        enterMonthlyRent: "Моля, въведете вашия месечен наем или ипотечен кредит",
        tip13: "Кажете ни дали имате ипотека",
        tip14: "Ако не е избрана гаранция за ипотека, вероятността за преминаване на прегледа е ниска.",
        isThereMortgage: "Има ли ипотека?",
        selectIsThereMortgage: "Моля изберете дали има ипотека",
        selectMortgageType: "Моля, изберете тип ипотека",
        yes: "да",
        no: "не",
        uploadScreenshotOfTransaction: "Моля, качете екранни снимки на транзакции",
        tip15: "Нека поддържаме връзка",
        tip16: "Може да се свържем с вас на този номер, ако се нуждаем от допълнителна информация относно вашето заявление за заем",
        tip17: "Прочетох и подписах електронно своето съгласие",
        tip18: "Условия за ползване и електронно съгласие",
        tip19: "Това включва вашето съгласие да ви изпращаме информация за нашите",
        tip20: "Условия за ползване на продукти и услуги",
        tip21: "След като попълните информацията, моля, изчакайте оценка и преглед на системата.",
        phoneNumber: "телефонен номер",
        enterPhoneNumber: "Моля, въведете своя телефонен номер",
        tip22: "Моля, поставете отметка в квадратчето, за да се съгласите с условията за ползване и електронния формуляр за съгласие",
        inReview: "в процес на преразглеждане",
        applicationAmount: "Сума за кандидатстване",
        reasonForRejection: "Причина за отказ",
        reapply: "Кандидатствайте отново",
        applyStatus: "състояние на приложението",
        currentOrder: "текуща поръчка",
        interestRate: "лихвен процент"
    },
    yuebao: {
        filed1: "инвестирам",
        filed2: "Извеждам",
        filed3: "Дневен доход",
        filed4: "екипно ускорение",
        filed5: "Депозиран",
        filed6: "Печалбата от вчера",
        filed7: "Общи приходи",
        filed8: "Налични средства",
        filed9: "Моля, въведете сумата",
        filed10: "Добив на ликвидност",
        filed11: "Въведение",
        field12: "Минимална покупна цена",
        field13: "Най-много можете да купите",
        filed14: "Абонамент",
        filed15: 'редовен',
        filed16: 'годишен лихвен процент',
    },
    tipsPopover: {
        title: "Инсталирайте това приложение",
        press: "Според",
        and: "и",
        scrren: "Добави към началния екран",
        hasInstall: "(Ако вече е инсталиран, моля, затворете прозореца)",
    },
    follow: {
        title1: "Последващ план",
        follow_text1: "Инициирайте последваща поръчка",
        follow_text2: "История на изданията",
        follow_text3: "заглавие",
        follow_text4: 'търговска двойка',
        follow_text5: 'Продължителност на покупката',
        follow_text6: 'време за поръчка',
        follow_text7: 'време на освобождаване',
        follow_text8: 'Брой последователи',
        follow_text9: 'Сума на поръчката',
        follow_text10: 'оперират',
        follow_text11: 'покани',
        follow_text12: 'Следвайте указанията на поръчката',
        follow_text13: 'Задайте условия за поръчка',
        follow_text14: 'Условия за следване на поръчки',
        follow_text15: 'фиксирана сума',
        follow_text16: 'процент',
        follow_text17: 'Поканени хора',
        follow_text18: 'ID на другата страна',
        follow_text19: "Потвърдете, за да следвате поръчката",
        follow_text20: "Вашата сума на поръчката (по избор)",
        follow_text21: "Моля, въведете заглавие",
        follow_text22: "Моля, изберете търговска двойка",
        follow_text23: "Моля, изберете посоката на поръчката",
        follow_text24: "Моля, изберете продължителност на покупката",
        follow_text25: "Моля, изберете часа на поръчката",
        follow_text26: "Моля, изберете количество за покупка",
        follow_text27: "Максималното количество за покупка не може да бъде по-малко от минималното количество за покупка",
        follow_text28: "Минимален бай-ин",
        follow_text29: "Повечето купуват",
        follow_text30: "Създаване на поръчка за копиране успешно",
        follow_text31: "Списък на търговски двойки",
        follow_text32: "Вече следвате поръчката",
        follow_text33: "Моля, въведете информация за поканения",
        follow_text34: "Поканен",
        follow_text35: "ме покани",
        follow_text36: "Копиране на историята",
        follow_text37: "Диапазон на сумата на поръчката",
        follow_text38: "Моля въведете кода за поръчка"
    },
    followHistory: {
        title1: 'История на изданията',
        title2: "Копиране на историята",
        follow_h_text1: "Общата сума на поръчката",
        follow_h_text2: "Общ брой хора, следващи поръчки",
        follow_h_text3: "Брой издания",
        follow_h_text4: "процент на печалба",
        follow_h_text5: "Брой пъти за изпълнение на заповеди",
        follow_h_text6: "Печалба от следване на поръчки",
        follow_h_text7: "посока",
        follow_h_text8: "печеля",
        follow_h_text9: "дефицит",
    },
    "asset.index.1579E8B41F8D5134": "моите активи",
    "asset.index.B3F6F05Dfbe431Cd": "симулация",
    "asset.index.B9Aeab4Ee8F33746": "Оценка на активите",
    "asset.index.583Df8Bd541Eb7E8": "тенденции в приходите",
    "asset.index.B1254815D133Cc26": "7 дни",
    "asset.index.2F615F6C029F01B7": "30 дни",
    "asset.index.29439Fb58E4Bbe22": "оттегляне",
    "asset.index.831Ab31568A78285": "допълнете",
    "asset.index.39F7A0D48D12E8C9": "трансфер",
    "asset.index.B99063C5689Beaec": "Флаш обмен",
    "asset.index.E1Dc620F2F038B2A": "Получавайте активи",
    "asset.index.972A0B4C2B4393D0": "моята сметка",
    "asset.index.9Dfb0Fb334620733": "Наличен баланс",
    "asset.index.Cdc5Fbd26790Cb47": "замразено количество",
    "asset.index.3D8132D72Ae965Cd": "Остойностяване",
    "asset.receive.825503Cc430559Cb": "придобиват активи",
    "asset.receive.54154A0553A535B7": "Демо активи",
    "asset.receive.F2E57B00A9C5D129": "1.Този актив е разрешено да се използва само в режим на демо сметка",
    "asset.receive.Ea0D1D52989299Bd": "2.За да се предотврати злоупотреба, е разрешено само едно обратно изкупуване в рамките на един месец.",
    "asset.receive.090E0037Aa235D3D": "3.Получаването на активи ще добави сумата на получените активи на първоначалната база и няма да промени състоянието на позицията.",
    "asset.receive.7Fd4E1Abc805C0A6": "4.Ако имате други въпроси, моля, свържете се с отдела за обслужване на клиенти",
    "asset.receive.Df5B3A511D986575": "Вземете демонстрационни активи сега",
    "asset.records.1Fa02E8187A39592": "последните три месеца",
    "asset.records.7B291C37333Fe34D": "от близо до далеч",
    "asset.records.A476Cd1Ec868Fc5F": "последните три месеца,",
    "asset.records.9D5755A842E55Bb7": "от близо до далеч,",
    "asset.records.E3Fa05E607203Cdc": "допълнете",
    "asset.records.B4F206C6Bec08Dea": "оттегляне",
    "asset.index.Df5B3A511D986576": "Успешно получихте демонстрационните активи",
    "deposit.depositSpeedy.Efe81D0E0174239B": "начин на плащане",
    "deposit.depositSpeedy.B9293Ee96E435F85": "Фиатна валута",
    "deposit.depositSpeedy.16658A855F07D171": "Количество",
    "deposit.depositSpeedy.204Ffab8A6E01870": "Сигурен",
    "deposit.depositSpeedy.22E5Dfb74Ead8Aa9": "Не може да бъде празно",
    "deposit.depositSpeedy.B8E774D0E4E5E4C1": "Минимално презареждане",
    "deposit.depositSpeedy.F169D816F6Dd83C5": "Максимално презареждане",
    "deposit.depositWallet.F64Ec60B1Db4A6D6": "Депозирайте USDT",
    "deposit.depositWallet.551640C76F4Ca4A1": "Валута за презареждане",
    "deposit.depositWallet.B404C543712B71D5": "Мрежа за презареждане",
    "deposit.depositWallet.A484B0F5E94B3F4F": "Адрес за депозит",
    "deposit.depositWallet.D3980D54Acf242Db": "Запазете QR кода",
    "deposit.depositWallet.A06E84801D6582Be": "Сума за презареждане",
    "deposit.depositWallet.Daaaeb1B7B22B126": "намек",
    "deposit.depositWallet.D599E40E1Eeec1B3": "Презареждането е успешно",
    "deposit.depositWallet.4F48Abbafce532Bb": "Изпратено успешно, чака се преглед от обслужване на клиенти",
    "deposit.depositWallet.A88C481228811696": "Отказахте да смените мрежата",
    "deposit.depositWallet.C6Ebf27895C21932": "Моля, отворете ръчно приставката за портфейла TRON и влезте",
    "deposit.index.B5491C8Dd09D8183": "Изберете валутата, която искате да презаредите",
    "deposit.index.2F784B2298D39987": "Бързо презареждане",
    "deposit.index.0Daa03Dcdcabd837": "Извънсайтови връзки",
    "withdraw.bottomSheet.628A63056Ef2D2Fe": "Потвърждение за теглене",
    "withdraw.bottomSheet.A086Fa20082C849D": "Моля, уверете се, че информацията по-долу е правилна",
    "withdraw.bottomSheet.Bf8B184D32971501": "Мрежа за теглене",
    "withdraw.bottomSheet.8758Fd50C87D6C9C": "адрес",
    "withdraw.bottomSheet.F9Db93B87E08763B": "количество",
    "withdraw.bottomSheet.4Ad26475002878C0": "такса за обработка",
    "withdraw.index.A96454041169Af6D": "Изберете валута",
    "withdraw.index.2A563B7081Dd5B83": "Адрес за теглене",
    "withdraw.index.B189C2Ef713Cfff4": "Количество изтеглени монети",
    "withdraw.index.558F35140E84B562": "На разположение：",
    "withdraw.index.F4E759087E12Cb77": "Изтеглете всички",
    "withdraw.index.5Cbd9A6B284D25Ae": "Парола за фонд",
    "withdraw.index.B89Cbe4Bfc33Bb41": "такса за обработка:",
    "withdraw.index.C886De8D8A27026E": "важно съобщение",
    "withdraw.index.Eac7C5A4095F5606": "1.За да предотвратите арбитраж, можете да кандидатствате за теглене на валута, когато обемът на транзакцията достигне квотата.",
    "withdraw.index.C3Cc7Fff24504Be9": "2.Заявлението за теглене ще бъде кредитирано в рамките на 24 часа след подаване. Ако тегленето не бъде получено след очакваното време за теглене, моля, свържете се с онлайн обслужването на клиенти.",
    "withdraw.index.0B4Ad7Ccdc833B0D": "3.След подаване на заявлението за теглене средствата са в замразено състояние, тъй като тегленето е в ход и средствата са временно задържани от системата. Това не означава, че сте загубили актива или че има нередност с актива.",
    "withdraw.index.4639F3A6E07C00B3": "Следваща стъпка",
    "withdraw.index.81Fba0D65Cc5C3Aa": "Моля, въведете или поставете адреса на вашия портфейл",
    "withdraw.index.25768141C8Bdea91": "Моля, въведете сумата за теглене",
    "withdraw.index.97A85734Cd1B7Bf0": "Моля, въведете паролата на фонда",
    "withdraw.index.39C7D74B33241C78": "Сумата за теглене е грешна",
    "withdraw.index.86A5D17908197525": "Потвърждение за теглене, изчакване на преглед за освобождаване на монети",
    "withdraw.index.48Fb603C6638C7F6": "Моля, задайте парола за фонд",
    "withdraw.index.873Ade9A3Bacc2F7": "намек",
    "bill.index.5Bbb2A6Ac68D6B2E": "действителна сметка",
    "bill.index.75751E0Eb8261C40": "Демо сметка",
    "bill.index.Cbc853B37Ecc2E97": "Тип промяна на акаунта",
    "bill.index.4A0Cacddeb2E38B1": "Тип на профила",
    "bill.index.F16217028E098B2F": "Валута",
    "bill.index.A620Dbe6F06B78Ba": "Всички видове",
    "bill.index.2C3C148Bb94D9B3F": "Всички акаунти",
    "c2C.index.Ab45695E4Bf1E382": "C2C транзакция",
    "c2C.index.2702Dc911Dfea762": "Искам да си купя",
    "c2C.index.D737D5B8367A53C4": "искам да продам",
    "c2C.index.C0C540A3Ba9Abe01": "Сила на звука",
    "c2C.index.D8644E8D60C8Bd8A": "единична цена",
    "c2C.index.Ebb8670B203D3604": "лимит",
    "c2C.index.F8C6245A2Ebf1D27": "Всички банкови карти",
    "c2C.index.F8C6245A2Ebf1D28": "събиране на валута",
    "c2C.index.F8C6245A2Ebf1D29": "банкова карта",
    "c2C.index.Cc3Aa8141Da9Ec9E": "Купува",
    "c2C.index.Cc3Aa8141Da9Ec9F": "продавам",
    "c2C.index.67A39834582Ad99A": "Няма данни",
    "c2C.order.04C23810B47F77F7": "по количество",
    "c2C.order.6905365902E0A73D": "по количество",
    "c2C.order.3F0Ecebbd9D2F23B": "На разположение",
    "c2C.order.16853Bda54120Bf1": "всичко",
    "c2C.order.Ad3335796F2C95F7": "еднократна сума",
    "c2C.order.61092E27A6879318": "За да защитите безопасността на активите, моля, повишете информираността си за превенцията!",
    "c2C.order.0F51881F0Fb920B2": "Информация за търговия",
    "c2C.order.Dd74Ceca85E5Bc65": "Срок на плащане",
    "c2C.order.De3341388A59073F": "30 минути",
    "c2C.order.D334B597A352167F": "Псевдоним на продавача",
    "c2C.order.D334B597A352167G": "Псевдоним на купувача",
    "c2C.order.9D5F89F99Ced890D": "средство за транзакция",
    "c2C.order.8Adf755B14Bc6B7C": "Моля, първо прочетете следното",
    "c2C.order.686B16F454A7338B": "Не правете забележки при извършване на преводи с банкова карта, в противен случай парите няма да бъдат пуснати и сметката ще бъде директно блокирана. След плащането трябва да предоставите нова диаграма с подробности за транзакцията след плащането (ако P диаграмата или скритите подробности за транзакцията се докладват на платформата, за да замрази акаунта)",
    "c2C.order.9Bec8Fba867B739B": "Изберете метод на плащане",
    "c2C.order.Cf2D892C419Fea36": "минимална покупка",
    "c2C.order.7290A6B7456A03E0": "най-голямата покупка",
    "c2C.orderConfirm.F7E99B8C203E2B07": "подробности за поръчката",
    "c2C.orderConfirm.036D94Dc2D1Cf7D3": "Поръчката е генерирана",
    "c2C.orderConfirm.0F5433503F3845Ce": "Моля, платете на продавача в рамките на времето за обратно броене.",
    "c2C.orderConfirm.24C3Bcacdb85A451": " Изчакване на плащане от купувача ",
    "c2C.orderConfirm.8E8140D7Ab607B24": "Свържи се с продавача",
    "c2C.orderConfirm.8E8140D7Ab607B25": "свържете се с купувача",
    "c2C.orderConfirm.Ec4D8722Ec15C813": "Дигиталната валута на продавача вече е депозирана в ескроу сметката, моля, не се колебайте да платите ",
    "c2C.orderConfirm.69D1Fbbc7700C1Ab": "Истинското име на купувача：",
    "c2C.orderConfirm.E5Ed8Ec53Edcd5D3": "7x24 часа поддръжка за обслужване на клиенти ",
    "c2C.orderConfirm.Abf9F4B8C93D641E": "Номер на поръчка",
    "c2C.orderConfirm.726C51702F70C486": "време на създаване",
    "c2C.orderConfirm.E097Bb9B1216Bfd8": "Свържете се с отдела за обслужване на клиенти",
    "c2C.orderConfirm.103408Fbbe30287F": "отмени поръчката",
    "c2C.orderConfirm.4E93Df1Fb521F4Ba": "Потвърдих плащането",
    "c2C.orderConfirm.3B5418Dbea7Ebfe4": "Вече платено",
    "c2C.orderConfirm.387Ca3625B260E4E": "Вашата платена поръчка",
    "c2C.orderConfirm.7C83D5F1Db1A08B7": "анулиране на транзакция",
    "c2C.orderConfirm.76C86566Cc3751C0": "Поръчката е отменена",
    "c2C.orderConfirm.205B349751D176B4": "плащането е успешно",
    "c2C.paymentAdd.6F2A7Dcc66E6Acba": "начин на плащане",
    "c2C.paymentAdd.C87E865Df6800304": "Конфигурация на метода на плащане",
    "c2C.paymentAdd.B59Ae0F1B1C235Df": "Тип метод на плащане",
    "c2C.paymentAdd.06910Bddf002695F": "действително име",
    "c2C.paymentAdd.3E33Ae3Efa7507Dd": "акаунт в PayPal",
    "c2C.paymentAdd.3E33Ae3Efa7507De": "Номер на банкова сметка/номер на карта",
    "c2C.paymentAdd.3E33Ae3Efa7507Df": "Име на валутата",
    "c2C.paymentAdd.595Ede91Abf6F6E0": "Платете QR код",
    "c2C.paymentAdd.1Ecc8Be9Ba1C940A": "Кликнете, за да качите",
    "c2C.paymentAdd.6Daae340F2E9718A": "име на банката",
    "c2C.paymentAdd.347751415C3Da489": "Име на веригата",
    "c2C.paymentAdd.15B3627Faddccb1D": "Забележка",
    "c2C.paymentAdd.86Da96Cbd274058F": "Напомняне: когато продавате цифрова валута, избраният от вас начин на плащане ще се покаже на купувача. Моля, потвърдете, че информацията е попълнена точно.",
    "c2C.paymentAdd.4Ce9979Bfb6576D9": "спаси",
    "c2C.paymentAdd.90D2A3A5C07179C0": "моля, въведете истинското си име",
    "c2C.paymentAdd.A3B0Cd3Ad9Ca3475": "Моля, въведете вашия",
    "c2C.paymentAdd.Ec389E6190Eedb62": "Моля, въведете името на вашата банка",
    "c2C.paymentAdd.9Be51Fb1E9025Fb2": "Моля, въведете името на вашата верига",
    "c2C.paymentAdd.94F034F0E01439E0": "Моля, въведете вашия адрес",
    "c2C.paymentAdd.B12E035663A42B32": "Всички банкови карти",
    "c2C.paymentAdd.C7B677F393A8F8Ac": "събиране на валута",
    "c2C.paymentAdd.Abafe11737Bab7Cd": "Моля, качете кода за плащане",
    "c2C.paymentAdd.07C443212Ff04Bfb": "Добавено успешно",
    "c2C.paymentDetail.86Da96Cbd274058F": "Напомняне: когато продавате цифрова валута, избраният от вас начин на плащане ще се покаже на купувача. Моля, потвърдете, че информацията е попълнена точно.",
    "c2C.paymentDetail.C4C613Da60226De4": "Успешно модифициран",
    "c2C.paymentMethod.7609F7C8337C7A17": "C2C метод на плащане",
    "c2C.records.9E36893D5736Abb4": "Списък с поръчки",
    "c2C.records.4B53F9A5B13B3235": "Предстоящо плащане",
    "c2C.records.4B53F9A5B13B3236": "анулиране на транзакция",
    "c2C.records.4B53F9A5B13B3237": "Вече платено",
    "contract.index.9706Df877458F0Be": "Пълен склад",
    "contract.index.623Fc7D3D40Aa479": "Първоначален марж",
    "contract.index.F92Dce1169330387": "Пазарната цена е равна",
    "contract.index.3598B97Dd28Dbf20": "Моля, въведете количество (броя)",
    "contract.index.6E1Fae821Dc0B797": "Устойчив",
    "contract.index.Eb07Eb0C37C14575": "Доставка",
    "contract.index.Eb6492F19B1C1Fb6": "Подробности за минали транзакции",
    "contract.index.873Ade9A3Bacc2F7": "намек",
    "contract.index.Ff63B0F93D39F50B": "Сигурен ли си, че си прав",
    "contract.index.Ff63B0F93D39F50D": "Отидете дълго",
    "contract.index.Ff63B0F93D39F50E": "къс",
    "contract.index.Ff63B0F93D39F50F": "поведение, ръководене",
    "contract.index.Ff63B0F93D39F50G": "Затворете всички позиции?",
    "customer.dialog.3D410C88E8A24Fe8": "Потвърдете псевдонима",
    "customer.dialog.4B3340F7872B411F": "Отказ",
    "customer.dialog.549B1456Bb5F98B3": "Моля, въведете псевдонима си",
    "customer.dialog.B773B3E45Ccfad00": "Псевдонимът е празен",
    "customer.index.7308C6B849D159E9": "Подробности за снимката",
    "delivery.callDialog.C74F562C3Fe91Fe3": "успешно поръчан",
    "delivery.callDialog.B8C98F42Caa15Ca5": "посока",
    "delivery.callDialog.B79A581Dae543974": "дълга покупка",
    "delivery.callDialog.B79A581Dae543975": "къса покупка",
    "delivery.callDialog.3B26F0F7E90773F3": "Начална цена",
    "delivery.callDialog.65Fb252Bd94E1039": "Очаквани приходи",
    "delivery.index.B483Ba4Fce633539": "Доставка",
    "delivery.index.224Dd6Cb58D58249": "период на търговия",
    "delivery.index.28158F517E902788": "Минимален бай-ин",
    "delivery.index.A1232162B14Bec76": "Поръчка за доставка",
    "delivery.index.445B1D3176D9C69D": "Исторически порядки",
    "delivery.index.Ab6Cb86E28653C5C": "Доставка",
    "delivery.index.20A7A6F14D3698C0": "Време на отваряне",
    "delivery.index.Ec6821A49395Ddc2": "Края на работното време",
    "delivery.index.254Fdc665C391743": "Цена на затваряне",
    "delivery.index.2A0C5E68B44A472A": "Печалба и загуба",
    "delivery.index.E05B33309F6D236A": "Моля, въведете количество",
    "delivery.index.B2899E073Cb355D9": "Минимална покупка",
    "download.description.869467A93C7Dd4A1": "Бележки за инсталиране",
    "download.description.C80C1Edd6Bee12Bc": "1.Разрешаване на изтегляне на файлове с описание",
    "download.description.2F5Bc180F92642B4": "2.Файлът с описание е изтеглен",
    "download.description.3C3B849F6Ccf712F": "3.Въведете [Настройки] на телефона си и изтегленият файл с описание ще се покаже под информацията за акаунта.",
    "download.description.86Affd862985E045": "4.Кликнете, за да изтеглите файла с описание",
    "download.description.32832492Bfc1D95E": "5.Кликнете, за да инсталирате",
    "download.index.245883C80F181C4A": "Изтегли",
    "download.index.Ef3De8Cb2722937A": "Започнете да търгувате по всяко време и навсякъде",
    "download.index.F4A87Eaeed691638": "Бъдете в крак с последните новини чрез нашето ПРИЛОЖЕНИЕ",
    "download.index.Ad3Aba52D0D39D01": "Изтеглете инсталационния пакет",
    "download.safariGuide.61Bd9A8Fcc2Ea788": "Любезни съвети",
    "download.safariGuide.2Cc68Aaadf623477": "Моля, посетете в Safari",
    "download.safariGuide.C80Fff2A6Ff4E768": "Посещавате децентрализиран уебсайт, моля, стартирайте в приложението safari",
    "download.safariGuide.06Da016F3E2F79Bd": "Копирай връзка",
    "finance.index.B034B367545D5236": "Глобални висококачествени проекти",
    "finance.index.6Ebfac2C0A9228B0": "1,6 милиона+ активни потребители, 122,4 милиарда долара",
    "finance.index.52Bdcaf19659363D": "Добив на ликвидност",
    "finance.index.D66924272B031Bf5": "Супер висок годишен доход",
    "finance.index.34789D88Afcefa64": "Преглед на елементите",
    "finance.index.E12676B95654D21E": "кредитен заем",
    "finance.index.4C924Cfd89A11Ac7": "Открийте повече възможности за търговия",
    "finance.index.C251D4B594Da2848": "AI количествено определяне",
    "finance.index.4E53Cf2E5F173Dd3": "Лизинг с едно кликване, AI интелигентна транзакция",
    "finance.records.Cce168301447D1Ba": "в ход",
    "finance.records.4587B6Bd7Cfa4454": "изкупен",
    "finance.records.18685418E3A50147": "Минен",
    "finance.records.Df9Fd438F97Cc908": "небе",
    "finance.records.E23Cb03C5Ad359E5": "срокът",
    "finance.records.Bd87Dac6Cba7Eba8": "Количество за покупка",
    "finance.records.2D0Fff99265E8B1A": "Печеливш",
    "finance.records.2D0Fff99265E8B1B": "Печалба на падежа",
    "finance.records.024F5F0B851782De": "Време за добив：",
    "finance.records.3143A26D3F983896": "време за обратно изкупуване：",
    "finance.records.96574Aaf8Db85Ead": "предсрочно изкупуване",
    "finance.records.531E1829203181Ac": "Сигурни ли сте, че искате да осребрите по-рано?;",
    "finance.records.9205843B8923Dac3": "Осребряването е успешно;",
    "loan.applyCallback.B9258Ec8746A74D8": "Канал за заемане",
    "loan.applyForm.7B8Ed340400A6E2B": "име",
    "loan.applyForm.549A44Bae725F4A2": "фамилия",
    "loan.applyForm.2A27E61375E7Fea8": "дата на раждане",
    "loan.applyForm.89925B019D537738": "имейл адрес",
    "loan.applyForm.Afaeb32Cb4D62E28": "Домашен адрес (включително номер на блок)",
    "loan.applyForm.E05B5D049B64B040": "град",
    "loan.applyForm.B166E4E8Fe9513Fa": "нация",
    "loan.applyForm.83Aaede109E395F8": "пощенски код",
    "loan.applyForm.647Ed21332A4968B": "вашият месечен доход",
    "loan.applyForm.Cf0A9B845D34D4B4": "Допълнителен доход (по избор)",
    "loan.applyForm.7048F618Acc6A54C": "Плащане на месечен наем или ипотека",
    "loan.applyForm.15C1Bba18Ae18545": "Кажете ни дали имате ипотека",
    "loan.applyForm.3921E90625A84E36": "Ако не е избрана гаранция за ипотека, вероятността за преминаване на прегледа е ниска.",
    "loan.applyForm.262Eec4F8906B0F6": "Има ли ипотека?",
    "loan.applyForm.8634Eb21B6910F21": "Моля, изберете тип ипотека",
    "loan.applyForm.A4897B3A331B5E61": "Ваучер за транзакция",
    "loan.applyForm.6623384C683De457": "Нека поддържаме връзка",
    "loan.applyForm.A8360Bdba86834Cb": "Може да се свържем с вас на този номер, ако се нуждаем от допълнителна информация относно вашето заявление за заем",
    "loan.applyForm.C1C373F385A4C7B3": "телефонен номер",
    "loan.applyForm.1B9785Badb91191F": "След като попълните информацията, моля, изчакайте оценка и преглед на системата.",
    "loan.applyForm.8755B9C761D4080C": "Прочетох и подписах електронно своето съгласие",
    "loan.applyForm.3E987B787468148C": "Условия за ползване и електронно съгласие",
    "loan.applyForm.Bc54E76B61C50Fb9": "Моля, прочетете и се съгласете със споразумението",
    "loan.applyForm.89E158384F634Eb8": "Prev",
    "loan.applyForm.Efa5A4548E2F3510": "Домашен адрес",
    "loan.applyForm.4Cadf1787541B35D": "да",
    "loan.applyForm.Fab408D2F4100447": "не",
    "loan.applyForm.3Bad7A307480Cc56": "Форматът на имейла е грешен;",
    "loan.applyForm.306322F49B36855D": "Заявлението е изпратено, моля, изчакайте преглед от обслужването на клиенти",
    "loan.applyForm.3C6E0E858C995Ff9": "Моля, качете ваучер за транзакция",
    "loan.applyForm.2Bf443476B271376": "Могат да се качват до 4 снимки",
    "loan.applyQuota.Ef1D8E23003B9A6F": "Канал за заемане",
    "loan.applyQuota.Ef1D8E23003B9A6G": "Вземете кредитен лимит",
    "loan.applyQuota.9E0780F9352C7273": "баланс на портфейла",
    "loan.applyQuota.Cbc1Eb9D639A6105": "Общата налична сума на заема",
    "loan.applyQuota.033A05462195B080": "Заета сума",
    "loan.applyQuota.9Aa89B036Ef4821D": "оставащ баланс",
    "loan.applyQuota.5656Fb52Ef17A557": "Вземете кредитен лимит",
    "loan.applyQuota.6Ff6702B4C917D40": "в процес на преразглеждане",
    "loan.applyQuota.6Ff6702B4C917D41": "отхвърлени",
    "loan.applyQuota.6Ff6702B4C917D42": "успели",
    "loan.applyQuota.0Bad0E857Ea4A952": "време на прилагане",
    "loan.applyQuota.3E7E56E2De2Cc546": "Сума за кандидатстване",
    "loan.applyQuota.8F1D170D9E54Af5B": "Напредък на приложението",
    "loan.applyQuota.6167Ca035B93Caf3": "причина",
    "loan.applyQuota.410C7954F9A3981D": "Кандидатствайте отново",
    "loan.bottomSheet.61Cd62F861D8F5B2": "Моля, изберете валута",
    "loan.index.4C10307B22E885C3": "Открийте повече възможности за търговия и създайте богатство",
    "loan.index.Ae8D37Dea2B3717B": "лихвен процент",
    "loan.index.1Bb54625682E85Db": "Въвеждане на правилото",
    "loan.index.5Bd31Fab681C6E9D": "виж повече",
    "loan.index.111F95F404814327": "Валута на заема",
    "loan.index.6Bc2723B3Bec106D": "заем",
    "loan.index.3200106280E6E370": "лихвен процент",
    "loan.index.049A6Ccb6C81A635": "Сума на заема (мин./макс.)",
    "loan.productDetails.5037Ad86Ab4B7E02": "заем",
    "loan.productDetails.37181C74559Db182": "Поръчка ",
    "loan.productDetails.5802Aaf06A1E4755": "Ликвидност",
    "loan.productDetails.89Aea9Cf9337C40F": "Налично количество за заемане",
    "loan.productDetails.9E419Ae2D06F3Ad9": "Количество за изплащане",
    "loan.productDetails.C65F329Ef14C4A3D": "Количество заети монети",
    "loan.productDetails.3A74667815Adc8Bf": "максимум",
    "loan.productDetails.Ab851D8351573227": "небе",
    "loan.productDetails.Ddf82D8A2C8F46A0": "погасителен цикъл",
    "loan.productDetails.C105E5562005Aeb1": "небе",
    "loan.productDetails.3F346Be2137F0756": "Сума на заема (мин./макс.)",
    "loan.productDetails.2707F78Df864E194": "интерес",
    "loan.productDetails.B9Dc9B81E726Bdf1": "Моля, погасете навреме, ако е просрочена, ще бъде начислена допълнителна дневна сума от (главница + лихва).",
    "loan.productDetails.B9Dc9B81E726Bdf2": "% е просрочена такса",
    "loan.productDetails.4D94Faa033Be7356": "Съгласих се",
    "loan.productDetails.62429A957A22780A": "Споразумение за услуга за заемане на монети",
    "loan.productDetails.Bc54E76B61C50Fb9": "Моля, прочетете и се съгласете със споразумението",
    "loan.productDetails.Ec8Ba071C53A67Cb": "Заемете сега",
    "loan.productDetails.59246A0Bf081D398": "най-малко",
    "loan.productDetails.Ec3F1172B71Cd36C": "минимална сума",
    "loan.productDetails.7Ccc4Cf1D81930B3": "най-голяма сума",
    "loan.productDetails.071488598990Aa68": "Моля, прочетете и се съгласете със споразумението;",
    "loan.productDetails.579Dd216D3339119": "Успешен заем;",
    "loan.records.4951B36Fd0D2A831": "Кредитна и кредитна история",
    "loan.records.Bb0Aaa30514B7Cba": "текущ рекорд",
    "loan.records.0F8B0A7D80769051": "История на погасяване",
    "loan.records.D4B42E43D88De6F1": "исторически запис",
    "loan.records.Cb1847D6281897E6": "Заета сума",
    "loan.records.C7Bfcacfc2Adea58": "Сума за погасяване",
    "loan.records.8B369164D5Fea340": "време за заем：",
    "loan.records.Ab2402Ad3Ffd35E7": "Изплатете заема предсрочно",
    "loan.records.B7A0Ca0C195D0Cd1": "Време за освобождаване：",
    "loan.records.42014Bdcfd9C411B": "Време за погасяване：",
    "loan.records.A0Acfaee54F06458": "завършен",
    "loan.records.67A39834582Ad99A": "Няма данни",
    "loan.records.6A687Ff5B8F1598F": "Сигурни ли сте, че искате да погасите предварително?",
    "loan.records.7C20D7008D0Eae86": "Успешно погасяване",
    "mining.bottomSheet.Ba91637D32Ccba04": "Добив на ликвидност",
    "mining.bottomSheet.7De3D636A165E008": "норма на възвращаемост",
    "mining.bottomSheet.F3003345B189D683": "Период на добив",
    "mining.bottomSheet.3E4C0A8C533F5848": "тип монета",
    "mining.bottomSheet.Adcba368993Ae65E": "Сума на абонамента (минимум/максимум)",
    "mining.bottomSheet.94743B24E4Ed4166": "Неограничен",
    "mining.bottomSheet.286944Fedd211257": "Налични средства",
    "mining.bottomSheet.7B5766Dc65Abc0C3": "Очаквани приходи:",
    "mining.bottomSheet.9Bbaf80Fdb6Fd148": "Моят сега",
    "mining.bottomSheet.Bb1493C567C114Dd": "Любезни съвети：",
    "mining.bottomSheet.D2315E87E34A3Bd3": "Такса за предсрочно изкупуване",
    "mining.index.8B2Bba1422Eed6F0": "Създайте десетки милиарди богатство, 100% нетен доход",
    "mining.index.42997E300086Ee89": "най-висока доходност",
    "mining.index.510F74F42052Ecce": "Минни продукти",
    "mining.index.B853F96626106912": "Отидете на копаене",
    "mining.productList.37181C74559Db182": "Поръчка",
    "mining.productList.Aac5B810004C46C8": "редовен",
    "mining.productList.D2Fb4F78C387D888": "Успешно копаете",
    "quantify.bottomSheet.9Ea4A318F690Bc95": "Потвърди поръчката",
    "quantify.bottomSheet.6915303B698303B1": "робот",
    "quantify.bottomSheet.68045296Dd0F8Ad6": "Размер на наема",
    "quantify.bottomSheet.Fbd931286Be387Aa": "цикъл",
    "quantify.bottomSheet.9Ad84Db481807844": "за неопределено време",
    "quantify.bottomSheet.994D7226Ca083Ea5": "Дневна норма на възвръщаемост",
    "quantify.bottomSheet.0Bf82Ee4Bfe063B7": "вальор",
    "quantify.bottomSheet.88008603Ba7Bde64": "Успешна покупка",
    "quantify.bottomSheet.Ff50B3091Bbd09Ab": "Вземете своя дял от приходите от днес!",
    "quantify.bottomSheet.C778A674C4A054F9": "проверка на поръчката",
    "quantify.bottomSheet.685Dad322B7029B0": "Транзакция за връщане",
    "quantify.buyForm.Acf8560A04334E95": "изкупна цена",
    "quantify.buyForm.Cf9Cfbc2C554944F": "Преглед",
    "quantify.buyForm.8788Df2B625E97B5": "робот",
    "quantify.buyForm.50Ca63B45E881D50": "Време за изплащане на дивидент",
    "quantify.buyForm.Fcda03Adbc5Fca97": "всеки ден",
    "quantify.buyForm.Afb89504Fc399189": "Моля, въведете количеството за покупка",
    "quantify.buyForm.1435Afdfb4Ec0596": "Минимално количество за покупка",
    "quantify.buyForm.1B97F1730Bacd839": "Максимално количество за покупка",
    "quantify.index.32F56C9B7D0E250A": "Срок: неопределен",
    "quantify.index.E34F028D00904630": "цена",
    "quantify.index.E34F028D00904631": "Дневна норма на възвръщаемост",
    "quantify.productDetail.6Bbe178Df539A5Ca": "Ескроу сума",
    "quantify.productDetail.53635B53Bca31Dfa": "Очакван дневен доход",
    "quantify.productDetail.F9E46449A6269E09": "Кумулативен доход",
    "quantify.productDetail.98Fc46B1B8C993B2": "Поръчайте хостинг",
    "quantify.productDetail.93624Bb045830966": "Наемете сега",
    "quantify.records.0C16A18C32B9Cf4A": "Запис на поръчката",
    "quantify.records.B191F5614B0E2312": "История на покупките",
    "quantify.records.6A06033B86A73F7C": "запис за обратно изкупуване",
    "quantify.records.45E0F7E71611618E": "Кумулативен доход",
    "quantify.records.45E0F7E71611618F": "Печалба на падежа",
    "quantify.records.Aae1201E38C4Baaa": "Бягане",
    "flash.index.C41Fd4F2Fdfa594B": "консумират",
    "flash.index.1Ac59Fa2218E3B00": "На разположение:",
    "flash.index.Bf7233A660821549": "получавам",
    "flash.index.548E775Dd67C7472": "Потвърдете размяната",
    "flash.index.066A2449Bd616F03": "Моля, въведете количеството за обратно изкупуване",
    "flash.index.Fca26Fcf9C06563F": "Флаш изкупуването успешно",
    "message.index.40031524233F4564": "Център за съобщения",
    "message.index.8E5586210Fd44D69": "Постоянно напомняне за позиция",
    "message.index.Bcd3F470E88C197D": "Все още няма известие",
    "message.index.23A557Fbce545879": "Известие за постоянна ликвидация",
    "message.index.B5E19B36B5125550": "Напомняне за теглене",
    "message.index.716A981465138334": "Напомняне за презареждане",
    "message.index.884474Ebff2977Ba": "системна информация",
    "message.index.08Cc7D24752Ec42C": "онлайн услуга",
    "message.index.1D820A6A19Ab025D": "7 X 24 часа онлайн ръчно обслужване",
    "more.index.29881E0B5Df58Bf7": "Още функции",
    "more.index.C77Ee35911D10D9D": "Общи функции",
    "more.index.3558F69B0260Be61": "Търговска функция",
    "more.index.7243Fe610Ed98Cec": "реална сметка",
    "more.index.7243Fe610Ed98Ced": "Демо сметка",
    "more.index.693C7B35Bdf3E3A3": "финанси",
    "more.index.F855997Fac114554": "Помощен център",
    "more.index.Ae9A1252278Da742": "помогне",
    "more.index.Ace012504Bc529E0": "информация",
    "more.index.05682Dbef5Eeb0A8": "обслужване на клиенти",
    "more.index.C7Af227A5D5C7Bb9": "Вие преминахте към акаунт на живо",
    "more.index.D818A65592694786": "Вие преминахте към демо акаунт",
    "notice.details.B360807Dbe727E6E": "за нас",
    "notice.details.92F2552F695E70E3": "за нас",
    "notice.details.7Aaceaf69B67F3D1": "Въвеждане на правилото",
    "notice.index.6128438Be34Bcb9F": "Безсрочно предизвестие",
    "notice.index.71627F5Eb7128261": "Известие за теглене",
    "notice.index.2Dce570Fda841705": "Известие за презареждане",
    "notice.index.228A7C9C6448A9B1": "системно известяване",
    "setting.dialog.8B4F5B74660Deabe": "Цветова конфигурация",
    "setting.dialog.Bfc7D25486Ebc1A9": "Зеленото се издига и червеното пада",
    "setting.dialog.796Ea0E1A82C320B": "Червеното се издига и зеленото пада",
    "setting.index.8Ddc5864E1739466": "Предпочитания",
    "setting.index.F5205801D57D6727": "език",
    "setting.index.2E2C12Dd0Cc1B63B": "Валута на котировката",
    "setting.index.322D8496Aec3D918": "номер на версията",
    "setting.index.Aa7E6C204C751Cfa": "отписване",
    "share.index.75Bc38Bbf7D2E766": "покани приятели",
    "share.index.45575Eb5D42213E6": "моя код за покана",
    "share.index.29F67F0644A78Bf3": "копие",
    "share.index.19Cc65Bb6Bb98Fe7": "Линкът ми за покана",
    "share.index.5372712F162Fb78B": "Брой преки подчинени",
    "share.index.C88D6B95E3Ab7D6F": "Общ брой подчинени",
    "share.index.Bb5Fa5471Aeecc62": "Комисионна отстъпка за преки подчинени",
    "share.index.426B6Bac9A5F3D4F": "обща отстъпка",
    "share.index.197E4A428F0401C9": "Вижте записите за отстъпки",
    "share.records.88A6B2E2B74B13C4": "Комисионен запис",
    "share.records.B671A35Ffdc93B89": "отстъпка",
    "transfer.index.B17617A869C03Ca5": "портфейл",
    "transfer.index.E4116Dcc6F6C7270": "Прехвърлянето успешно",
    "transfer.index.48Fb603C6638C7F6": "Моля, задайте парола за фонд",
    "transfer.records.Eb0E39Eb5911D418": "получавам",
    "transfer.records.977554Be0Aa65052": "Време за флаш изкупуване：",
    "transfer.records.9Aa33884Aa400B7C": "време за трансфер：",
    "form1.forget.76636Db8Fae5B124": "вашата пощенска кутия",
    "form1.forget.35354B9Cca1Bb0E6": "Код за потвърждение на имейл",
    "form1.forget.604A0B11E916F387": "парола",
    "form1.forget.9Cb1C9C51E7503D6": "потвърди парола",
    "form1.forget.3A4F7E04B008453C": "Вашият телефонен номер",
    "form1.forget.Cf11Dce5B4713B5A": "Код за потвърждение на мобилен телефон",
    "form1.forget.3012Edba57D4F297": "Моля, въведете своя имейл",
    "form1.forget.F1Ee1D97E869E447": "моля, въведете код за потвърждение",
    "form1.forget.3A5C4C9Ae68Fa0F6": "Моля въведете паролата си",
    "form1.forget.C6Cb174Da411D5F7": "Моля, въведете вашия мобилен телефон",
    "form1.forget.947B3B21Ee45E582": "изпрати",
    "form1.forget.3E0580F1E8630Df6": "Две пароли са несъвместими",
    "form1.forget.C5A61836B8Cc74C6": "Промяната на паролата бе успешно пренасочена...",
    "form1.forget.B96D072Bc8962565": "Повторно изпращане",
    "form1.login.2B72C27Ff828Cfc4": "твоята парола",
    "form1.login.D7C6B872Af9Cb17F": "запомни паролата ми",
    "form1.login.0Fff44C827A4F3B6": "Влизам",
    "form1.login.1B7F2C1Ede3990Cc": "Все още нямате акаунт? Включи се сега",
    "form1.login.F657F7Be1Cc33Bd2": "забравете паролата",
    "form1.login.2074A1Eec4B088B0": "Вход в Wallet",
    "form1.login.1B8938Fbcc3C9B56": "Успешно влизане и пренасочване...",
    "form1.login.07162A7Bb9310555": "Моля, инсталирайте ERC20 портфейл",
    "form1.login.766969966Ae151Dc": "Моля, инсталирайте портфейла TRC20",
    "form1.login.B88171E1Ad4C50Bf": "Отказахте да смените мрежата",
    "form1.register.Aaef0710Cb4Db554": "Въведете паролата отново",
    "form1.register.54Dfea0415C708Ff": "Код на поканата",
    "form1.register.6839940Dac08C794": "регистрирам",
    "form1.register.9901A3B5550Aa58E": "Вече имате акаунт? Влизам",
    "form1.register.2548Ca53785252Ea": "Моля, въведете своя код за покана",
    "form1.register.Dd71Fd65900Dd03E": "Моля, прочетете Споразумението за услугата по регистрация и се съгласете",
    "form1.register.7975613909490B77": "Успешна регистрация и пренасочване...",
    "form1.walletDialog.105829Acfc0Bd6Aa": "Изберете портфейл",
    "userc.certification.2Af9511640153D2E": "Junior Certification",
    "userc.certification.177B191D8E0Fa84D": "не е сертифициран",
    "userc.certification.601218D4D572E98A": "проверени",
    "userc.certification.6E37C51Ba9012Fc8": "Не мина",
    "userc.certification.1B9B563E05C96474": "Разширено сертифициране",
    "userc.certification.1418B83803Ab56B4": "Моля, първо попълнете основното сертифициране",
    "userc.creditScore.0B149112601Acc4D": "кредитен рейтинг",
    "userc.creditScore.88Ac7F84E106C5F6": "общ кредитен рейтинг",
    "userc.creditScore.3E1D6E0E7F1E6155": "Оценка на системата",
    "userc.index.62Eac58D04Bbca0F": "Персонален център",
    "userc.index.F4Cac53F93Cb2Aff": "симулирана търговия",
    "userc.index.42F409Fdf3559773": "Център за сигурност",
    "userc.index.1B8E211009807Db8": "Удостоверяване",
    "userc.index.Bdfcf21Eb8F2Eb70": "Записи за промени в акаунта",
    "userc.index.6C18D67F6D19586B": "Въведение в платформата",
    "userc.index.807A814Ed58A93Bc": "Изтрий кеш-памет",
    "userc.index.E43Daad59759611C": "не е сертифициран",
    "userc.secureCenter.F5C70F0Db2F1Ba76": "Промяна на паролата за вход",
    "userc.secureCenter.1F37Ba427Debf24A": "Обвързване на акаунта",
    "userc.secureCenter.F9A5Ffa750664004": "Свържете Google Authenticator",
    "userb.certificationForm.7685Af7D30043Cd6": "Junior Certification",
    "userb.certificationForm.7685Af7D30043Cd7": "Разширено сертифициране",
    "userb.certificationForm.70E37C35Abc3F462": "Държава",
    "userb.certificationForm.F92C25A68E4D08C5": "град",
    "userb.certificationForm.0Ccc6387B38E0318": "Твоето име",
    "userb.certificationForm.94C67Bba370Fdd46": "номер на лиценза",
    "userb.certificationForm.B2D4C7Fffe79258E": "поща",
    "userb.certificationForm.57554268761Fb47A": "Качете лицевата страна на личната си карта",
    "userb.certificationForm.D79E90201F5319Bd": "Качете гърба на личната си карта",
    "userb.certificationForm.9C6Bad08Af29E20E": "Качете снимка на вашата лична карта",
    "userb.certificationForm.F96B62Dfa31Cde45": "Потвърдете изпращането",
    "userb.certificationForm.2125D78Ea8C6D287": "Изисквания за качване",
    "userb.certificationForm.0D64864D3076A824": "Вижте пример",
    "userb.certificationForm.35287Deb72281E87": "1.Трябва да може ясно да чете информацията от личната карта.",
    "userb.certificationForm.3007F2E01Efc7B57": "2.Съдържанието на снимката е вярно и валидно и не се допуска промяна.",
    "userb.certificationForm.25A90660554319F9": "3.Идентификационният номер и името трябва да са ясно видими, да поддържат JPG / JPEG / PNG",
    "userb.certificationForm.5A9Aefbc03C778F7": "Моля, въведете",
    "userb.certificationForm.3B7A1D8Ce27C937E": "Изпращането е успешно, моля, изчакайте преглед",
    "userb.certificationForm.744Bd07D8Abd2513": "Моля, качете лицевата страна на вашия документ за самоличност",
    "userb.certificationForm.6De1C319130F7Fef": "Моля, качете гърба на личната си карта",
    "userb.certificationForm.79F8E8B172E30C8A": "Моля, качете снимка на вашата лична карта",
    "userb.certificationForm.46412E16D28A4753": "Неуспешно качване на снимка",
    "userb.changeDialog.676B0Adca1F8Eea4": "промяна на паролата",
    "userb.modifyInfoDialog.F41De3A1Fa69135A": "телефонен номер",
    "userb.modifyInfoDialog.3C3Aac9664A35Ef8": "ключ за валидатор",
    "userb.modifyInfoDialog.62149E566814154C": "Изберете валидатор",
    "userb.modifyInfoDialog.8E69468E2435Fc89": "Отворете приложението за удостоверяване и докоснете +",
    "userb.modifyInfoDialog.7625E5Bdcbfe9963": "Изберете „Сканиране на QR код“ или „Въвеждане на ключ“",
    "userb.modifyInfoDialog.93F094E2B4369472": "Сканирайте QR кода или въведете ключа",
    "userb.modifyInfoDialog.43E4F1532529Ee1E": "затвори/отвори",
    "userb.modifyInfoDialog.Bae6358Dfd95025A": "Стара парола за фонд",
    "userb.modifyInfoDialog.E1133Cd4B1C2Abb7": "Нова парола за фонд",
    "userb.modifyInfoDialog.C1Ce0403A2523Ee0": "Потвърдете новата парола за фонд",
    "userb.modifyInfoDialog.8Dd453Adc2Cd78Fb": "Потвърдете паролата на фонда",
    "userb.modifyInfoDialog.Bb0D9854C79325Bb": "Моля, въведете старата си парола за фонд",
    "userb.modifyInfoDialog.E66Cb29B00Bc54D1": "Моля, въведете новата си парола за фонд",
    "userb.modifyInfoDialog.E8Ae2Ec5Df401255": "Моля, въведете паролата на вашия фонд",
    "userb.modifyInfoDialog.258A534498Fe984F": "Моля, потвърдете паролата на вашия фонд",
    "userb.modifyInfoDialog.768Ec43Faa193F08": "Обвързване на акаунта",
    "userb.modifyInfoDialog.D34746090C25E5Db": "Парола за фонд",
    "userb.modifyInfoDialog.E4F27D8916E5E536": "потвърди",
    "userb.modifyInfoDialog.Bef7160Ce53773E0": "Валидаторът е затворен",
    "userb.modifyInfoDialog.Be8Bf47Ba6820De1": "Потвърждаването от Google е включено успешно",
    "userb.modifyInfoDialog.24Dba26593F43C74": "Паролата на фонда е променена успешно",
    "userb.modifyInfoDialog.5C369D42Dc7Dbe76": "Паролата за фонд е зададена успешно",
    "userb.modifyInfoDialog.667Bf8D0B6C36D4C": "Обвързването е успешно",
    "userb.modifyInfoDialog.1C5E05Efee2B0B9F": "Грешка в кода за потвърждение",
    "userb.veBottomSheet.Eecc4683C725F6F2": "Пример за качване на сертификат",
    "userb.veBottomSheet.6F38A0D5858633Ee": "тъмен чист фон",
    "userb.veBottomSheet.Af162Dbdfc4Fcae9": "Достатъчно осветление",
    "userb.veBottomSheet.0F7Baf0Cee3C8141": "Спомагателна рамка за подравняване",
    "userb.veBottomSheet.Ac9E471Eead0Cf11": "Снимките са ясни",
    "userb.veBottomSheet.50B741382E71F103": "Възможни причини за неуспех",
    "userb.veBottomSheet.Aa56C68E8Fd4Cfb4": "Защитното покритие на личната карта не е сваляно",
    "userb.veBottomSheet.5D2F429C75D4C7F2": "Фонът е повлиян от безпорядък",
    "userb.veBottomSheet.90F42D3Cb7769Dbc": "Личната карта е светлоотразителна",
    "userb.veBottomSheet.1Ee78Cee782D81B4": "Светлината е твърде тъмна/спряна от сянката на мобилния телефон",
    "userb.veBottomSheet.1A75D2Fc2614592B": "притежава лична карта",
    "home.home.C3525Eb110Db58Aa": "Още",
    "home.home.29761532Fc8Ebecc": "търговия",
    "home.home.F15Ea99Bfa6E1848": "Сертификат за безопасност, купувайте с увереност",
    "home.home.46E1Ab39Bae7182A": "бързо",
    "home.home.Fde2Eb7F6F3Dd800": "Бързи транзакции и лесна работа",
    "home.home.Ea4756Bc1642E0F1": "име",
    "home.home.B6B1127Ede1C97B4": "последна цена",
    "home.home.3587Ad870Eb0Ab86": "24H увеличаване и намаляване",
    "home.home.Cb1A4E14Ec2Cd2B5": "Открийте",
    "home.home.0F1B1Ac0E96A40D1": "Блокчейн",
    "home.home.8Eaefb1107A0E210": "Forex",
    "home.home.Ad65263D034Ea051": "ЛС",
    "home.home.5Fc1474Dbf74Ac1A": "земеделски продукти",
    "home.home.135318F4664F7773": "енергия",
    "kline.kLine.C96Ff250Cf6B8B84": "24h най-висока цена",
    "kline.kLine.6E8Be64F19D74565": "Обем на търговия за 24 часа",
    "kline.kLine.08A4Bfbe26A0F262": "24h най-ниска цена",
    "kline.kLine.8701Deb075066331": "24-часов обем на търговия (USDT)",
    "kline.kLine.Ea3C3052136C84Cd": "1 точка",
    "kline.kLine.B49Cca240E013124": "5 точки",
    "kline.kLine.F27A90Be97Ba3D6C": "15 марки",
    "kline.kLine.Ff3E62395B694384": "30 точки",
    "kline.kLine.C1993F9C6Db1A674": "Един час",
    "kline.kLine.Fd2Cbbae405E284C": "1 ден",
    "kline.kLine.C9Cd71904395042C": "януари",
    "kline.kLine.7D8127Ec18C7B8C7": "Купува",
    "kline.kLine.E3D3Ffdb9B3E5636": "Количество (броя)",
    "kline.kLine.6834Fec1838D8029": "Цена (USDT)",
    "kline.kLine.16C52Aae474Bc9Cd": "поръчка за продажба",
    "kline.kLine.B9Bea1A9A88D1419": "Отворете дълго",
    "kline.kLine.D36Cfa96Ee2B343B": "Отворено късо",
    "other.navigationBar.F6E62F9642018Cbb": "първа страница",
    "other.navigationBar.0Ec227161A47B49D": "Цитати",
    "other.navigationBar.29761532Fc8Ebecc": "търговия",
    "other.navigationBar.693C7B35Bdf3E3A3": "финанси",
    "other.navigationBar.9734C54620Eb09Af": "активи",
    "home.index.25Aa4Fc745150030": "крал на криптовалутите",
    "home.index.2D6Ecf8Faaa8B124": "По-бързо, по-добре, по-силно",
    "home.index.1Db26267D1041223": "Търгувайте лесно с над 1700 криптовалути",
    "home.index.F8E18C90C3E35618": "Включи се сега",
    "home.index.29761532Fc8Ebecc": "търговия",
    "home.index.D8A95E4506487452": "Популярни договори",
    "home.index.5Bd31Fab681C6E9D": "виж повече",
    "home.index.010Ae07A09Caf221": "търговска двойка",
    "home.index.F4D875118E6D6Dbb": "Цена на последната сделка",
    "home.index.3Dfdfb3D6599100E": "24-часово увеличение и намаление на цената",
    "home.index.28Fb39Bd41E54242": "тенденция",
    "home.index.B47A3911Bacd94C6": "Списък на печелившите",
    "home.index.712910D574F43D95": "Стабилен доход",
    "home.index.5507Fd830D7Bf51F": "Топ стратегии, лесни за копиране",
    "home.index.7De3D636A165E008": "норма на възвращаемост",
    "home.index.B853F96626106912": "Отидете на копаене",
    "home.index.213B5C96Be7Cd1F8": "дни, годишен лихвен процент",
    "home.index.213B5C96Be7Cd1F9": "Максимална възможност за закупуване",
    "home.index.Dc710Cffe6313Bb5": "проверете подробностите",
    "home.index.B92Ffc837Ecaa1Dd": "Новини",
    "home.index.6C18D67F6D19586B": "Въведение в платформата",
    "home.index.6342E3C33Cb48Cd5": "Цифровата валута е средство за обмен, което използва криптографски принципи, за да гарантира сигурността на транзакциите. За разлика от фиатните валути като щатския долар, цифровите валути нямат физическа форма. Популярни цифрови валути като Bitcoin (BTC), Ethereum (ETH) и Polkadot (DOT) използват blockchain като основна технология, за да действат като децентрализирана цифрова книга. Всички транзакции с цифрова валута се записват в блокчейна и не могат да бъдат променяни, след като бъдат потвърдени и проверени. За разлика от традиционните валути, където банките поддържат централизирани счетоводни книги, транзакциите с цифрова валута се извършват в публична блокова верига и могат да бъдат достъпни от всеки.",
    "home.index.198Efc4254683Eef": "Освен това, според консенсусния механизъм, всеки може да проверява транзакции с цифрова валута и да ги добавя към блокчейна, като по този начин се постига децентрализация. Тъй като водещи световни компании като Samsung, BlackRock, Morgan Stanley и Alphabet са инвестирали, хората вярват, че блокчейн технологията напълно ще промени глобалната финансова система. Дигиталната валута отваря вратата към света на децентрализираните финанси за вас, като ви позволява да изследвате безкрайните възможности, предоставени от най-съвременните технологии.",
    "home.index.E710339D9576292E": "Нашето предимство",
    "home.index.F9Ce8B2C63885B26": "безопасно и стабилно",
    "home.index.C4D0A2C9Ff0305Ce": "Топ технически екип, всеобхватна защита на сигурността, независимо проучване и разработване на високоскоростен двигател за синтез на транзакции, все още могат да работят стабилно и надеждно при масивни едновременни транзакции.",
    "home.index.2E8708Ee3F11Cc1A": "Професионален и надежден",
    "home.index.Bb12Cbcf89C56C5C": "Професионален оперативен екип, с дългогодишен опит в блокчейн и финанси, притежава съвместим лиценз за търговия с цифрови активи и има 100% гаранция за резерв.",
    "home.index.Aa4723Bfbf6808F4": "Сервирайте със сърце",
    "home.index.1Bf0204B7D3Ee230": "С лице към глобалния пазар, поддръжка на множество езици, работа 24/7, силна поддръжка от общността и професионално обслужване на клиенти.",
    "home.index.2E7Dfd53D26F7224": "висока производителност",
    "home.index.1C65453103B5Fcc3": "300 000 транзакции в секунда и време за отговор на поръчката под 1 милисекунда.",
    "home.index.85Ac49Ece9Dcc80B": "Търгувайте по всяко време и навсякъде!",
    "home.index.2799E18842E4Ebe9": "Открийте незабавно позиция, поддържана както от приложението OKEX, така и от уеб страницата!",
    "home.index.2Bf52Ce75E29Fc88": "Сканирайте кода, за да го изтеглите сега",
    "home.index.88D1422B33571066": "Android",
    "home.index.04Ee893775563F21": "IOS",
    "home.index.04Ee893775563F22": "продуктово обслужване",
    "home.index.04Ee893775563F23": "финансово управление",
    "home.index.04Ee893775563F24": "връщане",
    "home.index.04Ee893775563F25": "В очакване на тегленето на лотарията",
    "home.index.04Ee893775563F26": "IOS & ANDROID",
    "homepage.text1": "Целта е да се превърнем в първи избор за ",
	"homepage.text1_2": "клиентите при търговия със стокови фючърси",
	"homepage.text2": "Вашето пътуване в света на криптовалутите",
	"homepage.text4": "Високо лихвено финансово управление",
	"homepage.text5": "Стабилно финансово управление, високогодишен доход",
	"homepage.text6": "Споделяне на награди",
	"homepage.text7": "Бързи сделки, лесна операция",
	"homepage.text8": "Виж повече",
	"homepage.text9": "Незабавно разменяне",
	"homepage.text10": "Сигурно удостоверение, покупка с увереност",
	"homepage.text11": "Водещ технологичен екип, пълна сигурност",
	"homepage.text12": "Защита, независимост",
	"homepage.text13": "Професионално и надеждно",
	"homepage.text14": "Професионален екип за управление, с многогодишен опит в блокчейн и финанси",
	"homepage.text15": "Отдадени обслужване",
	"homepage.text16": "Глобално ориентиран пазар, поддръжка на множество езици, операция 24/7",
	"homepage.text17": "Висока производителност",
	"homepage.text18": "Обработка на 300,000 сделки на секунда, време за отговор на поръчка по-малко от 1 милисекунда",
    "passwod.limit":"Дължината на паролата трябва да е по-голяма или равна на 6 знака",
    "finance.header.E5Dd9Bbdab4F52D2": "Помощ за инвестиране",
	"finance.header.5Cbf11665B91D51D": "Добавяне на баланс",
	"finance.index2.B1A4Be8079A937F8": "Диапазон за покупка на сума",
	"finance.index2.8371E53029Dc7558": "Глобална такса за ранно изтегляне",
	"finance.index2.Bf9A2C9Bf7Ecaf04": "Коефициент на заеми",
	"finance.index2.2Ad78Bbd879C4990": "Незабавно покупуване",
	"finance.index2.A3B7445Ea9D7E111": "Неприложимо за покупка",
	"finance.index2.A3B7445Ea9D7E112": "Приложимо за покупка",
	"finance.index2.87701Fe9Ad8540Dc": "Общ брой акции, налични за записване/акции, налични за записване",
	"finance.index2.652Effdf5D1Af6A2": "Очакван доходен процент",
	"finance.index2.D3C3C19De952Fc0C": "Дата на покупка",
	"finance.index2.6C4C46Cc4Da0C281": "Текуща сума",
	"finance.index2.3E9A6703Abd8A3E4": "Вчерашен доход",
	"finance.index2.596704E9869C8134": "Общ доход",
	"finance.index2.0A845B549624B74B": "Годишен процент на доходност",
	"finance.index2.9A7758Cad0402366": "Текущо притежание",
	"finance.index2.9A7758Cad0402367": "Записи за доход",
	"finance.index2.8B8Ceb7610C747Eb": "Исторически записи",
	"finance.index2.8B8Ceb7610C747Ec": "Записи за вложения",
	"finance.index2.0B049108D57B9Dd5": "Предварително изтегляне",
	"finance.index2.37Ffde1Ee1D3C8D4": "Вече предварително изтеглено",
	"finance.index2.12F6B830Aee90Efb": "Изтекъл срок",
	"finance.index2.40E1944D8Cafbdad": "Държана сума",
	"finance.index2.9815C4F248B624F5": "Дата на закупуване",
	"finance.index2.46F7Be1133B3E2C6": "Дата на приключване",
	"finance.index2.Fc8643Aa7Babcce8": "Доход",
	"finance.index2.1F2B02E97721B997": "Дали да предварително изтегляме",
	"finance.index2.14E543A74595Efe8": "В процес на заявка",
	"finance.index2.14E543A74595Efe9": "В процес",
	"finance.index2.14E543A74595Efe0": "Приключено",
	"finance.index2.8E29Fbba37286B63": "Име на наставник",
	"finance.index2.D736C17Df71Bcdb2": "Сума на заявката",
	"finance.index2.F38884Ed4410D9F6": "Успешно одобрена сума",
	"finance.index2.E3347Eb6F76Eda1C": "Вече получен доход",
	"finance.index2.0Fc0070Cb4E9F5A8": "Дата на влагане",
	"finance.index2.8Efd11Be6D9F43Df": "Начало на периода на доходност",
	"finance.index2.16658A855F07D171": "Сума",
	"finance.index2.184333C81Babf2F1": "Тип",
	"finance.index2.15Cba911299D4Afd": "Незабавно покупуване",
	"finance.index2.Da1Cdb155Ae381Cd": "Сума за изтегляне",
	"finance.index2.15Efec8F145F2608": "Текуща сума (USDT) : ",
	"finance.index2.159253C05C270D46": "Държана сума (USDT) : ",
	"finance.index2.Caab3A4Ba941E0E3": "Такса за предварително изтегляне (USDT) : ",
	"finance.index2.Fb5Fc50Cf3716723": "Може да се купува",
	"finance.index2.5Dcb4Ee5C7F1F4E1": "Въведете сума",
	"finance.index2.5886C88906Cc4491": "Екип от звездни наставници, грижи се за всеки един от вашите пари",
	"finance.index2.5886C88906Cc4492": "Гарантиран доход, гъвкавост при изтегляне, печелене във вълнения пазар",
	"finance.index2.F5Af24Dbad5837Ea": "Успешно изтегляне",
    "finance.index2.Be15Df7F1D76F9B2": "Сума за инвестиране",
	"finance.index2.596704E9869C8134": "Общ доход",
	"finance.index2.Fc57951B528F3Dd3": "Може да се заеме",
	"finance.index2.3F91F76109Fdbdeb": "Вече заето",
	"finance.index2.F68600F93Fe31213": "Заем",
	"finance.index2.494E47D4025Da8E6": "Връщане",
	"finance.index2.27F6657Ebf2025E3": "Сума на заем",
	"finance.index2.27F6657Ebf2025E4": "Сума за връщане",
	"finance.index2.631Fc4Ce8Aeee66F": "Потвърждение на заем",
	"finance.index2.631Fc4Ce8Aeee66G": "Потвърждение на връщане",
    "time.text1":"Начална дата",
    "finance.index2.631Fc4Ce8Aeee66H": "да се потвърди",
    "passwod.limit":"Дължината на паролата трябва да е по-голяма или равна на 6 знака",
    'turntable.title': 'Теглене на късмет',
    'turntable.title2': 'Голямо теглене на късмет',
    'turntable.sub': 'Късметът те очаква',
    'turntable.count': 'Брой тегления: ',
    'turntable.rule': 'Правила за теглене',
    'turntable.history': 'Запис на печалби',
    'turntable.tip1': 'Поздравления, спечелихте',
    'turntable.tip2': 'За съжаление, не спечелихте',
    'volume1':'Обем на търговията'
}
